import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { forkJoin, of } from "rxjs";
import { catchError, switchMap, map } from "rxjs/operators";
import { MetaPromocion, PromotionConfig } from "src/app/model/promotion-models";
import { CommissionPromotionsService } from "src/app/services/commission-promotions.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-modal-config-promotion",
  templateUrl: "./modal-config-promotion.component.html",
  styleUrls: ["./modal-config-promotion.component.css"],
})
export class ModalConfigPromotionComponent implements OnInit {
  mode: String = "";
  promotionId: number = 0;
  isHistorico: boolean = false;
  snapshot: any;

  public viewStatus: number = 0;

  public typeConfigurationCatalog = [
    { id: 0, description: "ESQUEMA" },
    { id: 1, description: "PROMOCIÓN" }
  ];

  public plazosCatalog = [
    { id: 5, name: "12", comission: 0 },
    { id: 6, name: "18", comission: 0 },
    { id: 7, name: "24", comission: 0 },
    { id: 8, name: "30", comission: 0 },
    { id: 9, name: "36", comission: 0 },
    { id: 10, name: "42", comission: 0 },
    { id: 11, name: "48", comission: 0 },
    { id: 12, name: "60", comission: 0 }
  ];

  public nuevoClienteCatalog: any[] = [
    { id: 1, description: "NUEVO CLIENTE" },
    { id: 2, description: "SEGUNDO CREDITO" },
    { id: 3, description: "3 O MÁS CRÉDITOS ACTIVOS" }
  ];

  // Catalogos
  public promotionSchemaCatalog: PromotionConfig[];
  public employeeJobCatalog: any[] = [];
  public businessProductCatalog: any[] = [];
  public genderCatalog: any[] = [];
  public civilStatusCatalog: any[] = [];
  public typeEmployeeCatalog: any[] = [];
  public typeSaleCatalog: any[] = [];
  public regionCatalog: any[] = [];
  public stateCatalog: any[] = [];
  public sucursalCatalog: any[] = [];
  public dependenciesCatalog: any[] = [];
  public productCatalog: any[] = [];
  public categoriesCatalog: any[] = [];
  public clavePromocionCatalog: any[] = [];

  // Catalogos - Vista
  public stateViewCatalog: any[] = [];
  public sucursalViewCatalog: any[] = [];
  public categoriesViewCatalog: any[] = [];
  public productViewCatalog: any[] = [];
  public dependenciesViewCatalog: any[] = [];
  public paymentCategoryCatalog: any[] = [];

  // Selected
  public selectedPromotionSchemaCatalog: any[] = [];
  public selectedTypeConfigurationCatalog: any[] = [];
  public selectedEmployeeJobCatalog: any[] = [];
  public selectedBusinessProductCatalog: any[] = [];
  public selectedGenderCatalog: any[] = [];
  public selectedCivilStatusCatalog: any[] = [];
  public selectedTypeEmployeeCatalog: any[] = [];
  public selectedTypeSaleCatalog: any[] = [];
  public selectedNuevoClienteCatalog: any[] = [];
  private _selectedSchemaForDropdown: any[] = [];

  // Propiedad para guardar los IDs de tipoAsesor del backend
  public listTipoAsesorBackend: any[] = [];

  public asesorCatalog: any[] = [];
  public asesorViewCatalog: any[] = [];
  public tempAsesorNumber: string = '';
  public configuracionExclusivaAsesores: boolean = false;
  public modoTasaAnual: number = 0;

  // Modal de campos
  public showFieldsModal = false;
  public selectedFieldIds: number[] = [];

  public promoConfiguration = {
    typeConfiguration: null,
    schema: null,
    promotionName: null,
    effectiveDate: this.getDateAddDays(30),
    effectiveSince: this.getToday(),
    typeAsesor: [],
    businessLine: [],
    comisionPromotion: null,
    typeComission: 0,
    exclusivaAsesores: false,
    modoTasaAnual: 0,
    gender: [],
    minAge: 0,
    maxAge: 100,
    civilStatus: [],
    typeEmployee: [],
    typeSale: [],
    advantageRefi: 0,
    minValueSale: 0,
    percentDiference: 0,
    baseInitDate: null,
    baseEndDate: null,
    compareInitDate: null,
    compareEndDate: null,
    observations: null,
    region: [],
    estado: [],
    sucursal: [],
    dependencia: [],
    producto: [],
    paymentTerms: [],
    categoryAsesor: [],
    minCapitalAmount: 0,
    maxCapitalAmount: 10000000,
    tasaAnual: 0,
    clavePromocion: [],
    nuevoCliente: [],
    asesores: [],
    metas: [],
  };

  public checkErrorsForm = {
    selectedTypeConfiguration: false,
    selectedSchema: true,
    inputPromotionName: true,
    inputEffectiveDate: false,
    selectedTypeAsesor: false,
    selectedBusinessLine: false,
    inputComisionPromotion: true,
    selectedGender: false,
    inputMinAge: false,
    inputMaxAge: false,
    selectedCivilStatus: false,
    selectedTypeEmployee: false,
    selectedTypeSale: false,
    inputAdvantageRefi: false,
    inputMinValueSale: false,
    inputPercentDiference: false,
    inputBaseInitDate: false,
    inputBaseEndDate: false,
    inputCompareInitDate: false,
    inputCompareEndDate: false,
    includeRegion: false,
    includeEstado: false,
    includeSucursal: false,
    includeDependencia: false,
    includeProducto: false,
    tooglePaymenTerm: false,
    toogleCategoryAsesor: false,
    inputMinCapitalAmount: false,
    inputMaxCapitalAmount: false,
    inputTasaAnual: false,
    includeClavePromocion: false,
    selectedNuevoCliente: false,
    includeAsesor: false,
    inputObservaciones: false
  };

  public showConfig = {
    fieldAsesorType: false,
    fieldBusinessLine: false,
    fieldGender: false,
    fieldAge: false,
    fieldCivilStatus: false,
    fieldEmployeeType: false,
    fieldSaleType: false,
    fieldRefi: false,
    fieldSaleAmount: false,
    fieldRegion: false,
    fieldState: false,
    fieldSucursal: false,
    fieldDependency: false,
    fieldProduct: false,
    fieldPaymentTerm: false,
    fieldCategoryAsesor: false,
    fieldCapitalAmount: false,
    fieldCommissionPromotion: true,
    fieldTasaAnual: false,
    fieldClavePromocion: false,
    fieldNuevoCliente: false,
    fieldAsesor: false,
    fieldDatePromoIni: false,
    fieldDatePromoFin: false,
    fieldMontoObjetivo: false
  };

  placeholderCommission = "Ingresa comisión...";
  vigenciaEditable = false;

  sectionOpen = {
    promocion: true,
    asesor: true,
    cliente: true,
    capital: true,
    geografia: true,
    asesores: true,
    observaciones: true,
    metas: true,
  };

  // ── Metas ───────────────────────────────────────────────────────
  // Cambiar la propiedad para que funcione en ambos modos
  public metasCatalog: MetaPromocion[] = [];
  public metaSeleccionada: MetaPromocion = null;
  public showMetaForm = false;
  public metaIdCounter = -1; // IDs negativos para metas locales sin guardar
  public metaComisionesExistentes: any[] = [];


  // Meta en edición
  public metaForm = {
    metaPromocionId: null,
    fechaInicio: this.getToday(),
    fechaFin: this.getToday(),
    fechaCorte: this.getToday(),
    objetivo: null,
    comisionMeta: null,
  };

  constructor(
    private toastr: ToastrService,
    private commissionPromotionsService: CommissionPromotionsService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  ngOnInit(): void {

    this.route.queryParams.subscribe(params => {
      this.mode = params['mode'] || 'consult';
      this.promotionId = params['promotionId'] ? +params['promotionId'] : 0;
    });
    // ← Leer snapshot desde sessionStorage
    const snapshotRaw = sessionStorage.getItem('snapshot_preview');

    if (snapshotRaw) {
      try {
        this.snapshot = JSON.parse(snapshotRaw);
        // ← Limpiar inmediatamente para no reutilizarlo en navegaciones posteriores
        sessionStorage.removeItem('snapshot_preview');
        this.isHistorico = true;
        console.info('Snapshot cargado desde sessionStorage:', this.snapshot);
      } catch (err) {
        console.error('Error al parsear snapshot desde sessionStorage:', err);
        sessionStorage.removeItem('snapshot_preview');
      }
    }

    this.getCatalogs();
    this.promoConfiguration.typeConfiguration =
      this.typeConfigurationCatalog.find(type => type.id == 0);
    this.selectTypeConfiguration();
  }



  /* ── Computed properties ─────────────────────────────────────── */
  get isEditMode(): boolean { return this.viewStatus === 2; }
  get isCreateMode(): boolean { return this.viewStatus === 1; }
  get isFormVisible(): boolean { return this.viewStatus === 1 || this.viewStatus === 2; }
  get headerTitle(): string { return this.isEditMode ? 'Detalles de la configuración' : 'Crear nueva configuración'; }
  get saveButtonText(): string { return 'Guardar'; }
  get saveButtonClass(): string { return this.isEditMode ? 'btn-warning' : 'btn-primary'; }
  get showSaveButton(): boolean { return this.isCreateMode || this.editableBoolean(); }
  get showVigenciaSelector(): boolean { return this.isCreateMode && !this.checkErrorsForm.selectedSchema; }
  get showAddThirtyDaysButton(): boolean { return this.isEditMode && !this.checkErrorsForm.selectedSchema; }
  get isVigenciaDisabled(): boolean { return this.isCreateMode ? !this.vigenciaEditable : false; }
  get isSchemaDisabled(): number { return this.isEditMode ? 1 : 0; }
  get isCommissionRadioDisabled(): boolean { return this.isEditMode; }
  get minEffectiveDate(): string {
    return this.isEditMode
      ? this.promoConfiguration.effectiveSince
      : this.getToday();
  }
  get selectedSchemaForDropdown(): any[] {
    if (this.isEditMode && this._selectedSchemaForDropdown.length === 0) {
      return this.selectedPromotionSchemaCatalog;
    }
    return this._selectedSchemaForDropdown;
  }
  set selectedSchemaForDropdown(value: any[]) { this._selectedSchemaForDropdown = value; }

  /* ── Guardar ─────────────────────────────────────────────────── */

  saveConfiguration() {

    const userId = localStorage.getItem('UserId');

    if (!this.promoConfiguration.promotionName || this.promoConfiguration.promotionName.trim() === '') {
      this.toastr.error('Ingresa un nombre para la configuración');
      this.checkErrorsForm.inputPromotionName = true;
      return;
    }

    const promocionBuilt = this.commissionPromotionsService.buildPromocionFrom(
      this.promoConfiguration,
      userId,
      this.showConfig,
      this.metasCatalog
    );

    if (this.isEditMode && this.listTipoAsesorBackend.length) {
      this.promoConfiguration.typeAsesor = this.promoConfiguration.typeAsesor.map((ta: any) => {
        const existente = this.listTipoAsesorBackend.find(
          (b: any) => b.tipoAsesorId === ta.id
        );
        return {
          ...ta,
          campoTipoAsesorId: existente ? existente.campoTipoAsesorId : null,
          promocionId: this.promotionId,
        };
      });
    }

    if (this.isEditMode) {
      this.edit();
    } else {
      this.save();
    }
  }

  save(): void {
    if (!this.checkErrorsAlerts()) return;
    this.viewStatus = 0;

    const userId = localStorage.getItem('UserId');

    // ← Enriquecer metas con metaSchema desde su filtro local
    const metasEnriquecidas = this.metasCatalog.map((meta: any) => ({
      ...meta,
      metaSchema: meta.filtro && meta.filtro.estructura ? {
        promotionSchemaId: meta.filtro.estructura.estructuraId,
        promotionSchemaName: meta.filtro.estructura.nombreEstructura,
        campos: meta.filtro.estructura.campos || [],
      } : null,
      metaShowConfig: null, // ← el buildFiltroPayload usará listPlazo del filtro
      metaPlazosCatalog: null,
      metaPaymentCategoryCatalog: null,
      metaCategoriesView: null,
    }));

    this.promoConfiguration.exclusivaAsesores = this.configuracionExclusivaAsesores;
    this.promoConfiguration.modoTasaAnual = this.modoTasaAnual;

    this.commissionPromotionsService
      .crearPromocionCompleta(
        this.promoConfiguration,
        userId,
        this.showConfig,
        metasEnriquecidas  // ← metas enriquecidas
      )
      .subscribe(
        (resp) => {
          if (resp.httpStatusCode === 200) {
            Swal.fire(
              'SE HA GUARDADO CON ÉXITO LA PROMOCIÓN CONFIGURADA',
              this.metasCatalog.length > 0
                ? `Se crearon ${this.metasCatalog.length} meta(s) correctamente`
                : '',
              'success'
            );
            this.close('success');
          } else {
            this.viewStatus = 1;
            Swal.fire('OCURRIÓ ALGÚN ERROR, NO SE LOGRÓ GUARDAR LA PROMOCIÓN',
              resp.messageError || '', 'error');
          }
        },
        (error) => {
          console.error(error);
          this.viewStatus = 1;
          Swal.fire('OCURRIÓ ALGÚN ERROR, NO SE LOGRÓ GUARDAR LA PROMOCIÓN', '', 'error');
        }
      );
  }

  edit() {
    if (this.checkErrorsAlerts()) {
      this.viewStatus = 0; // ← activar spinner
      this.promoConfiguration.metas = this.metasCatalog;
      this.promoConfiguration.exclusivaAsesores = this.configuracionExclusivaAsesores;
      this.promoConfiguration.modoTasaAnual = this.modoTasaAnual;
      this.commissionPromotionsService
        .editPromotionConfig(this.promoConfiguration, this.promotionId, this.showConfig, this.metasCatalog)
        .subscribe(
          (resp) => {
            if (resp.httpStatusCode === 200) {
              Swal.fire("SE HA MODIFICADO CON ÉXITO LA PROMOCIÓN", "", "success");
              this.close("success");
            } else {
              this.viewStatus = 2; // ← restaurar vista en error
              Swal.fire("OCURRIÓ ALGÚN ERROR, NO SE LOGRÓ EDITAR LA PROMOCIÓN", "", "error");
            }
          },
          (error) => {
            console.error(error);
            this.viewStatus = 2; // ← restaurar vista en error
            Swal.fire("OCURRIÓ ALGÚN ERROR, NO SE LOGRÓ EDITAR LA PROMOCIÓN", "", "error");
          }
        );
    }
  }

  close(motivo: string) {
    if (this.isHistorico) {
      this.router.navigate(['/promociones/consulta-historico-configuracion'], {
        queryParams: { promotionId: this.snapshot.promocionId, promotionName: this.snapshot.nombrePromocion }
      });
    } else {
      this.router.navigateByUrl("/promociones/configurador");
    }
  }

  /* ── Catálogos ───────────────────────────────────────────────── */

  getCatalogs() {
    forkJoin([
      this.commissionPromotionsService.getCatalogPromotionSchemasAndConfigurations()
        .pipe(catchError(() => { this.toastr.error("Error al leer esquemas."); return of(null); })),
      this.commissionPromotionsService.getRegion()
        .pipe(catchError(() => { this.toastr.error("Error al leer regiones."); return of(null); })),
      this.commissionPromotionsService.getState()
        .pipe(catchError(() => { this.toastr.error("Error al leer estados."); return of(null); })),
      this.commissionPromotionsService.getSucursal()
        .pipe(catchError(() => { this.toastr.error("Error al leer sucursales."); return of(null); })),
      this.commissionPromotionsService.getAsesorType()
        .pipe(catchError(() => { this.toastr.error("Error al leer tipos de asesores."); return of(null); })),
      this.commissionPromotionsService.getCategoryAsesor()
        .pipe(catchError(() => { this.toastr.error("Error al leer categorías de asesor."); return of(null); })),
      this.commissionPromotionsService.getDependency()
        .pipe(catchError(() => { this.toastr.error("Error al leer dependencias."); return of(null); })),
      this.commissionPromotionsService.getProduct()
        .pipe(catchError(() => { this.toastr.error("Error al leer productos."); return of(null); })),
      this.commissionPromotionsService.getSaleType()
        .pipe(catchError(() => { this.toastr.error("Error al leer tipos de venta."); return of(null); })),
      this.commissionPromotionsService.getGender()
        .pipe(catchError(() => { this.toastr.error("Error al leer géneros."); return of(null); })),
      this.commissionPromotionsService.getCivilStatus()
        .pipe(catchError(() => { this.toastr.error("Error al leer estado civil."); return of(null); })),
      this.commissionPromotionsService.getEmployeeType()
        .pipe(catchError(() => { this.toastr.error("Error al leer tipos de empleados."); return of(null); })),
      this.commissionPromotionsService.getBusinessLine()
        .pipe(catchError(() => { this.toastr.error("Error al leer línea de negocio."); return of(null); })),
      this.commissionPromotionsService.getClavePromocion()
        .pipe(catchError(() => { this.toastr.error("Error al leer claves de promoción."); return of(null); })),
    ]).subscribe(([
      respSchemas, respRegion, respState, respSucursal,
      respAsesorType, respCategoryAsesor, respDependency, respProduct,
      respSaleType, respGender, respCivilStatus, respEmployeeType,
      respBusinessLine, respClavePromocion,
    ]) => {

      if (respSchemas && respSchemas.data) {
        this.promotionSchemaCatalog = respSchemas.data.map((schema: any) => {
          if (schema.fields) {
            schema.fields = schema.fields.filter((f: any) => f.activeId == 1);
          }
          return schema;
        });
      }

      if (respRegion && respRegion.data) {
        this.regionCatalog = respRegion.data.map((e: any) => ({
          _id: e.id, _name: e.description
        }));
      }

      if (respState && respState.data) {
        this.stateCatalog = respState.data.map((e: any) => ({
          _id: e.id, _name: e.description, _regionId: e.fatherId, _region: e.father
        }));
      }

      if (respSucursal && respSucursal.data) {
        this.sucursalCatalog = respSucursal.data.map((e: any) => ({
          _id: e.id, _name: e.description, _estadoId: e.fatherId, _estado: e.father
        }));
      }

      if (respAsesorType && respAsesorType.data) {
        this.employeeJobCatalog = respAsesorType.data.map((e: any) => ({
          id: e.id, description: e.description
        }));
      }

      if (respCategoryAsesor && respCategoryAsesor.data) {
        this.categoriesCatalog = respCategoryAsesor.data.map((e: any) => ({
          id: e.id, selected: false, name: e.description,
          commission: 0, fatherId: e.fatherId, father: e.father
        }));
      }

      if (respDependency && respDependency.data) {
        let counter = 1;
        this.dependenciesCatalog = respDependency.data.map((e: any) => ({
          _id: counter++, _id_int: e.id, _name: e.description,
          _productId: e.fatherId, _product: e.father, core: e.core
        }));
      }

      if (respProduct && respProduct.data) {
        let counter = 1;
        this.productCatalog = respProduct.data.map((e: any) => ({
          _id: counter++, _id_int: e.id, _name: e.description,
          _bussinesLineId: e.fatherId, _bussinesLine: e.father, core: e.core
        }));
      }

      if (respSaleType && respSaleType.data) {
        // /CatSaleType/List trae activos e inactivos; solo se ofrecen los activos en el selector.
        // Identidad exclusivamente por saleTypeId (nunca por descripción).
        this.typeSaleCatalog = respSaleType.data
          .filter((e: any) => e.activeId)
          .map((e: any) => ({
            id: e.saleTypeId, description: e.description
          }));
      }

      if (respGender && respGender.data) {
        this.genderCatalog = respGender.data.map((e: any) => ({
          id: e.id, description: e.description
        }));
      }

      if (respCivilStatus && respCivilStatus.data) {
        this.civilStatusCatalog = respCivilStatus.data.map((e: any) => ({
          id: e.id, description: e.description, core: e.core
        }));
      }

      if (respEmployeeType && respEmployeeType.data) {
        this.typeEmployeeCatalog = respEmployeeType.data.map((e: any) => ({
          id: e.id, description: e.description, core: e.core
        }));
      }

      if (respBusinessLine && respBusinessLine.data) {
        this.businessProductCatalog = respBusinessLine.data.map((e: any) => ({
          id: e.id, description: e.description, core: e.core
        }));
      }

      if (respClavePromocion && respClavePromocion.data) {
        let counter = 1;
        this.clavePromocionCatalog = respClavePromocion.data.map((e: any) => ({
          _id: counter++, _id_int: e.id, _name: e.description, core: e.core
        }));
      }

      if (this.isHistorico) {
        // ← Snapshot: datos ya disponibles, procesar directo
        this.viewStatus = 2;
        this.getPromocion(this.snapshot);
        console.log('Respuesta del back isHistoric:', this.snapshot);
      } else if (this.mode === 'consult' || this.mode === 'edit') {
        // ← Consulta al backend: esperar respuesta DENTRO del subscribe
        this.commissionPromotionsService.getPromocion(this.promotionId).subscribe(
          (resp) => {
            if (resp.httpStatusCode === 200) {
              const data = resp.data;
              console.log('Respuesta del back getCaatalog:', data);
              this.viewStatus = 2;
              this.getPromocion(data); // ← mismo método que snapshot
            } else {
              this.toastr.error('Ocurrió un error al buscar la promoción solicitada');
              this.close('cancel');
            }
          },
          (error) => {
            console.error(error);
            this.toastr.error('Ocurrió un error al buscar la promoción solicitada');
            this.close('cancel');
          }
        );
      } else {
        this.viewStatus = 1;
      }
    });
  }

  /* ── getPromocion ────────────────────────────────────────────── */

  getPromocion(promotion: any) {
    let data = promotion;
    console.log("Respuesta del back getPromocion: ", data);

    // ── 1. Activar campos del schema ────────────────────────
    data.estructura.campos
      .filter((campo: any) => campo.activoId == 1)
      .forEach((campo: any) => this.activarCampoPorId(campo.campoId));

    Object.keys(this.checkErrorsForm).forEach(
      key => this.checkErrorsForm[key] = false
    );

    this.selectedPromotionSchemaCatalog.push(data.estructura.estructuraId);
    this.promoConfiguration.schema = {
      promotionSchemaId: data.estructura.estructuraId,
      promotionSchemaName: data.estructura.nombreEstructura,
      campos: data.estructura.campos || [],
    };

    this.selectedFieldIds = data.estructura.campos
      .filter((c: any) => c.activoId == 1)
      .map((c: any) => c.campoId);

    // ── 2. Campos simples ───────────────────────────────────
    this.promoConfiguration.typeConfiguration = this.typeConfigurationCatalog
      .find(t => t.id === data.tipoConfiguracionId) || this.typeConfigurationCatalog[0];
    this.promoConfiguration.promotionName = data.nombrePromocion;
    this.promoConfiguration.effectiveDate = data.fechaVigenciaFin
      ? data.fechaVigenciaFin.split('T')[0]
      : this.getDateAddDays(30);

    this.promoConfiguration.effectiveSince = data.fechaVigenciaInicio
      ? data.fechaVigenciaInicio.split('T')[0]
      : this.getToday();
    this.promoConfiguration.comisionPromotion = data.comision;
    this.promoConfiguration.typeComission = data.comisionAditiva;
    this.promoConfiguration.observations = data.observaciones;

    this.promoConfiguration.exclusivaAsesores = data.exclusivaAsesores == null || data.exclusivaAsesores == undefined ? false : data.exclusivaAsesores;
    this.configuracionExclusivaAsesores = this.promoConfiguration.exclusivaAsesores;

    this.promoConfiguration.minAge = (data.listEdad && data.listEdad.length && data.listEdad[0].edadMinima != null)
      ? data.listEdad[0].edadMinima : 0;
    this.promoConfiguration.maxAge = (data.listEdad && data.listEdad.length && data.listEdad[0].edadMaxima != null)
      ? data.listEdad[0].edadMaxima : 100;
    this.promoConfiguration.advantageRefi = (data.listRefis && data.listRefis.length && data.listRefis[0].porcentajeAvance != null)
      ? data.listRefis[0].porcentajeAvance : 0;
    this.promoConfiguration.minValueSale = (data.listMontoVenta && data.listMontoVenta.length && data.listMontoVenta[0].valorMinimoVenta != null)
      ? data.listMontoVenta[0].valorMinimoVenta : 0;
    this.promoConfiguration.percentDiference = (data.listMontoVenta && data.listMontoVenta.length && data.listMontoVenta[0].porcentajeDiferencia != null)
      ? data.listMontoVenta[0].porcentajeDiferencia : 0;
    this.promoConfiguration.baseInitDate = (data.listMontoVenta && data.listMontoVenta.length)
      ? data.listMontoVenta[0].fechaInicioBase : null;
    this.promoConfiguration.baseEndDate = (data.listMontoVenta && data.listMontoVenta.length)
      ? data.listMontoVenta[0].fechaFinBase : null;
    this.promoConfiguration.compareInitDate = (data.listMontoVenta && data.listMontoVenta.length)
      ? data.listMontoVenta[0].fechaInicioComparacion : null;
    this.promoConfiguration.compareEndDate = (data.listMontoVenta && data.listMontoVenta.length)
      ? data.listMontoVenta[0].fechaFinComparacion : null;
    this.promoConfiguration.minCapitalAmount = (data.listMontoCapital && data.listMontoCapital.length && data.listMontoCapital[0].montoCapitalMinimo != null)
      ? data.listMontoCapital[0].montoCapitalMinimo : 0;
    this.promoConfiguration.maxCapitalAmount = (data.listMontoCapital && data.listMontoCapital.length && data.listMontoCapital[0].montoCapitalMaximo != null)
      ? data.listMontoCapital[0].montoCapitalMaximo : 10000000;
    this.promoConfiguration.tasaAnual = (data.listTasaAnual && data.listTasaAnual.length)
      ? data.listTasaAnual[0].tasaAnual : 0;

    this.promoConfiguration.observations = data.observaciones;

    this.modoTasaAnual = (data.listTasaAnual && data.listTasaAnual.length)
      ? data.listTasaAnual[0].modo : 0;

    // ── 3. Reset listas ─────────────────────────────────────
    this.promoConfiguration.typeAsesor = [];
    this.promoConfiguration.businessLine = [];
    this.promoConfiguration.gender = [];
    this.promoConfiguration.civilStatus = [];
    this.promoConfiguration.typeEmployee = [];
    this.promoConfiguration.typeSale = [];
    this.promoConfiguration.region = [];
    this.promoConfiguration.estado = [];
    this.promoConfiguration.sucursal = [];
    this.promoConfiguration.dependencia = [];
    this.promoConfiguration.producto = [];
    this.promoConfiguration.paymentTerms = [];
    this.promoConfiguration.categoryAsesor = [];
    this.promoConfiguration.clavePromocion = [];
    this.promoConfiguration.nuevoCliente = [];

    this.selectedEmployeeJobCatalog = [];
    this.selectedBusinessProductCatalog = [];
    this.selectedGenderCatalog = [];
    this.selectedCivilStatusCatalog = [];
    this.selectedTypeEmployeeCatalog = [];
    this.selectedTypeSaleCatalog = [];
    this.selectedNuevoClienteCatalog = [];
    this.listTipoAsesorBackend = [];

    // ── 4. Cargar listas del backend ────────────────────────

    if (data.listTipoAsesor && data.listTipoAsesor.length) {
      this.listTipoAsesorBackend = data.listTipoAsesor;
      data.listTipoAsesor
        .filter((e: any) => e.tipoAsesorId != null)
        .forEach((e: any) => {
          this.selectedEmployeeJobCatalog.push(e.tipoAsesorId);
          const idx = this.employeeJobCatalog.findIndex(a => a.id === e.tipoAsesorId);
          if (idx !== -1) this.promoConfiguration.typeAsesor.push(this.employeeJobCatalog[idx]);
        });
    }

    if (data.listLineaNegocio && data.listLineaNegocio.length) {
      data.listLineaNegocio
        .filter((e: any) => e.lineaNegocioId != null)
        .forEach((e: any) => {
          this.selectedBusinessProductCatalog.push({
            id: e.lineaNegocioId, description: e.lineaNegocioValor, core: e.core
          });
          this.businessProductCatalog
            .filter(l => l.id === e.lineaNegocioId && l.core === e.core)
            .forEach(l => this.promoConfiguration.businessLine.push(l));
        });
    }

    if (data.listGenero && data.listGenero.length) {
      data.listGenero
        .filter((e: any) => e.generoId != null)
        .forEach((e: any) => {
          this.selectedGenderCatalog.push(e.generoId);
          const idx = this.genderCatalog.findIndex(g => g.id === e.generoId);
          if (idx !== -1) this.promoConfiguration.gender.push(this.genderCatalog[idx]);
        });
    }

    if (data.listEstadoCivil && data.listEstadoCivil.length) {
      data.listEstadoCivil
        .filter((e: any) => e.estadoCivilId != null)
        .forEach((e: any) => {
          this.selectedCivilStatusCatalog.push({
            id: e.estadoCivilId, description: e.estadoCivilValor, core: e.core
          });
          const idx = this.civilStatusCatalog.findIndex(
            s => s.id === e.estadoCivilId && s.core === e.core
          );
          if (idx !== -1) this.promoConfiguration.civilStatus.push(this.civilStatusCatalog[idx]);
        });
    }

    if (data.listTipoEmpleado && data.listTipoEmpleado.length) {
      data.listTipoEmpleado
        .filter((e: any) => e.tipoEmpleadoId != null)
        .forEach((e: any) => {
          this.selectedTypeEmployeeCatalog.push({
            id: e.tipoEmpleadoId, description: e.tipoEmpleadoValor, core: e.core
          });
          const idx = this.typeEmployeeCatalog.findIndex(
            t => t.id === e.tipoEmpleadoId && t.core === e.core
          );
          if (idx !== -1) this.promoConfiguration.typeEmployee.push(this.typeEmployeeCatalog[idx]);
        });
    }

    if (data.listTipoVenta && data.listTipoVenta.length) {
      data.listTipoVenta
        .filter((e: any) => e.tipoVentaId != null)
        .forEach((e: any) => {
          this.selectedTypeSaleCatalog.push(e.tipoVentaId);
          const idx = this.typeSaleCatalog.findIndex(s => s.id === e.tipoVentaId);
          if (idx !== -1) this.promoConfiguration.typeSale.push(this.typeSaleCatalog[idx]);
        });
    }

    if (data.listNuevoCliente && data.listNuevoCliente.length) {
      data.listNuevoCliente
        .filter((e: any) => e.nuevoClienteId != null)
        .forEach((e: any) => {
          this.selectedNuevoClienteCatalog.push(e.nuevoClienteId);
          const idx = this.nuevoClienteCatalog.findIndex(n => n.id === e.nuevoClienteId);
          if (idx !== -1) this.promoConfiguration.nuevoCliente.push(this.nuevoClienteCatalog[idx]);
        });
    }

    if (data.listClavePromocion && data.listClavePromocion.length) {
      data.listClavePromocion
        .filter((e: any) => e.clavePromocionId != null)
        .forEach((e: any) => {
          const idx = this.clavePromocionCatalog.findIndex(
            c => c._id_int === e.clavePromocionId
          );
          if (idx !== -1) this.promoConfiguration.clavePromocion.push(this.clavePromocionCatalog[idx]);
        });
    }

    // ── Región: cargar si fieldRegion activo ────────────────
    if (data.listRegion && data.listRegion.length) {
      data.listRegion
        .filter((e: any) => e.regionId != null)
        .forEach((e: any) => {
          const idx = this.regionCatalog.findIndex(r => r._id === e.regionId);
          if (idx !== -1) this.promoConfiguration.region.push(this.regionCatalog[idx]);
        });
    }

    // ── Metas ───────────────────────────────────────────────
    if (data.listMetaPromocion && data.listMetaPromocion.length) {
      this.metasCatalog = data.listMetaPromocion.map((m: any) => ({
        metaPromocionId: m.metaPromocionId,
        catPromotionId: m.catPromotionId,
        fechaInicio: m.fechaInicio,
        fechaFin: m.fechaFin,
        fechaCorte: m.fechaCorte,
        objetivo: m.objetivo,
        activa: m.activa,
        comisiones: m.comisiones || [],
        filtro: m.filtro || null,
      }));
    } else {
      this.metasCatalog = [];
    }

    // ── Asesores sin plazos ─────────────────────────────────
    if (data.listPagoAsesor && data.listPagoAsesor.length && !this.showConfig.fieldPaymentTerm) {
      this.asesorViewCatalog = data.listPagoAsesor.map((e: any, i: number) => ({
        id: i + 1, number: e.asesorId,
        name: `Asesor ${e.asesorId}`, amount: e.comision, plazos: null
      }));
      this.asesorCatalog = [...this.asesorViewCatalog];
    }

    // ── Plazos sin categorías ───────────────────────────────
    if (this.showConfig.fieldPaymentTerm && !this.showConfig.fieldCategoryAsesor) {
      if (data.listPlazo && data.listPlazo.length) {
        data.listPlazo
          .filter((e: any) => e.plazoValor != null)
          .forEach((e: any) => {
            const idx = e.plazoId != null
              ? this.plazosCatalog.findIndex(p => p.id === e.plazoId)
              : this.plazosCatalog.findIndex(p => p.name === e.plazoValor);
            if (idx !== -1) {
              this.plazosCatalog[idx].comission = e.comision;
              this.promoConfiguration.paymentTerms.push(this.plazosCatalog[idx]);
            }
          });
      }
    }

    // ── Categorías sin plazos ───────────────────────────────
    if (!this.showConfig.fieldPaymentTerm && this.showConfig.fieldCategoryAsesor) {
      if (data.listCategoriaAsesor && data.listCategoriaAsesor.length) {
        data.listCategoriaAsesor
          .filter((e: any) => e.categoriaAsesorId != null)
          .forEach((e: any) => {
            const idx = this.categoriesCatalog.findIndex(c => c.id === e.categoriaAsesorId);
            if (idx !== -1) this.categoriesCatalog[idx].selected = true;
          });
      }
    }

    // ── Asesores con plazos ─────────────────────────────────
    if (this.showConfig.fieldPaymentTerm && this.showConfig.fieldAsesor
      && data.listPagoAsesor && data.listPagoAsesor.length) {
      const asesorMap = data.listPagoAsesor.reduce((acc: any, curr: any) => {
        if (curr.asesorId) {
          if (!acc[curr.asesorId]) {
            acc[curr.asesorId] = {
              id: Object.keys(acc).length + 1,
              number: curr.asesorId,
              name: `Asesor ${curr.asesorId}`,
              amount: null, plazos: []
            };
          }
          acc[curr.asesorId].plazos.push({
            plazoId: curr.plazoId, plazoName: curr.plazoName, amount: curr.comision
          });
        }
        return acc;
      }, {});

      this.asesorViewCatalog = Object.values(asesorMap).map((asesor: any) => ({
        ...asesor,
        plazos: this.plazosCatalog.map(p => {
          const existing = asesor.plazos.find((pl: any) => pl.plazoId === p.id);
          return { plazoId: p.id, plazoName: p.name, amount: existing ? existing.amount : 0 };
        })
      }));
      this.asesorCatalog = [...this.asesorViewCatalog];
    }

    this.updateAsesoresConfiguration();

    // ── 5. Fallbacks PRIMERO ────────────────────────────────
    if (!this.showConfig.fieldRegion) {
      this.promoConfiguration.region = [...this.regionCatalog];
    }
    if (!this.showConfig.fieldAsesorType) {
      this.promoConfiguration.typeAsesor = [...this.employeeJobCatalog];
    }
    if (!this.showConfig.fieldBusinessLine) {
      this.promoConfiguration.businessLine = [...this.businessProductCatalog];
    }

    // ── 6. Calcular vistas derivadas ────────────────────────
    this.selectRegion();
    this.selectTypeAsesor();
    this.selectBussinesLine();
    this.selectTypeConfiguration();

    // ── 7. Cargar campos activos DESPUÉS de selectRegion ────

    // Estados — solo si fieldState activo
    if (this.showConfig.fieldState && data.listEstado && data.listEstado.length) {
      this.promoConfiguration.estado = [];
      data.listEstado
        .filter((e: any) => e.estadoId != null)
        .forEach((e: any) => {
          const idx = this.stateCatalog.findIndex(s => s._id === e.estadoId);
          if (idx !== -1) this.promoConfiguration.estado.push(this.stateCatalog[idx]);
        });
      this.selectState(); // ← recalcular sucursales
    }

    // Sucursales — solo si fieldSucursal activo
    if (this.showConfig.fieldSucursal && data.listSucursal && data.listSucursal.length) {
      this.promoConfiguration.sucursal = [];
      data.listSucursal
        .filter((e: any) => e.sucursalId != null)
        .forEach((e: any) => {
          const idx = this.sucursalCatalog.findIndex(s => s._id === e.sucursalId);
          if (idx !== -1) this.promoConfiguration.sucursal.push(this.sucursalCatalog[idx]);
        });
    }

    // Productos — solo si fieldProduct activo. Producto es catálogo local: identidad únicamente por productoId/_id_int.
    if (this.showConfig.fieldProduct && data.listProducto && data.listProducto.length) {
      const selectedProductIds = new Set(
        (data.listProducto || []).map((item: any) => Number(item.productoId))
      );

      this.promoConfiguration.producto = this.productCatalog.filter(product =>
        selectedProductIds.has(Number(product._id_int))
      );
      this.selectProduct(); // ← recalcular dependencias
    }

    // Dependencias — solo si fieldDependency activo
    if (this.showConfig.fieldDependency && data.listDependencia && data.listDependencia.length) {
      this.promoConfiguration.dependencia = [];
      data.listDependencia
        .filter((e: any) => e.dependenciaId != null)
        .forEach((e: any) => {
          this.dependenciesCatalog
            .filter(d => d._id_int === e.dependenciaId && d.core === e.core)
            .forEach(d => this.promoConfiguration.dependencia.push(d));
        });
    }

    // ── Plazos x Categorías ─────────────────────────────────
    if (this.showConfig.fieldPaymentTerm && this.showConfig.fieldCategoryAsesor) {
      if (data.listCategoriaAsesor && data.listCategoriaAsesor.length) {
        data.listCategoriaAsesor
          .filter((e: any) => e.categoriaAsesorId != null)
          .forEach((e: any) => {
            const idx = this.categoriesCatalog.findIndex(c => c.id === e.categoriaAsesorId);
            if (idx !== -1) this.categoriesCatalog[idx].selected = true;
          });
      }
      const listPlazo = data.listPlazo || [];
      this.paymentCategoryCatalog = this.plazosCatalog.map((plazo: any) => ({
        plazoName: plazo.name,
        paymentCat: this.categoriesViewCatalog.map((cat: any) => {
          const regla = listPlazo.find(
            (p: any) => p.plazoId === plazo.id && p.categoriaId === cat.id
          );
          return {
            plazoId: plazo.id,
            plazoName: plazo.name,
            categoryId: cat.id,
            categoryName: cat.name,
            comission: regla ? regla.comision : 0,
          };
        })
      }));
    }

    // ← Categorías sin plazos — poblar categoryAsesor
    if (!this.showConfig.fieldPaymentTerm && this.showConfig.fieldCategoryAsesor) {
      this.promoConfiguration.categoryAsesor = this.categoriesViewCatalog
        .filter(c => c.selected);
    }

    if (this.showConfig.fieldCategoryAsesor) {
      this.changePaymentCatoryAsesor();
    } else {
      // Solo plazos: reconstruir paymentTerms desde plazosCatalog
      this.promoConfiguration.paymentTerms = this.plazosCatalog.filter(
        p => p.comission > 0
      );
    }

    // ← Limpiar flags de error porque ya hay datos válidos
    this.checkErrorsForm.toogleCategoryAsesor = false;
    this.checkErrorsForm.tooglePaymenTerm = false;
    // ← Limpiar error de observaciones si ya tiene datos
    this.checkErrorsForm.inputObservaciones =
      !this.promoConfiguration.observations ||
      this.promoConfiguration.observations.trim() === '';
  }

  /* ── Selección y validaciones ────────────────────────────────── */

  uniqueSelection(event: any[], propertie: string, check: string, selectedProp: string) {
    if (!event || event.length === 0 || event[0] === undefined) {
      console.warn('Selección vacía ignorada para:', propertie);
      return;
    }
    this.promoConfiguration[propertie] = event[0];
    this.checkErrorsForm[check] =
      this.promoConfiguration[propertie] == null ||
      this.promoConfiguration[propertie] == undefined;
    if (selectedProp) {
      this[selectedProp] = [event[0][this.getIdPropBySelectedProp(selectedProp)]];
    }
  }

  private getIdPropBySelectedProp(selectedProp: string): string {
    const mapIdProps = {
      'selectedSchemaForDropdown': 'promotionSchemaId',
      'selectedTypeConfigurationCatalog': 'id'
    };
    return mapIdProps[selectedProp] || 'id';
  }

  multipleSelection(event: any[], propertie: string, check: string) {
    this.promoConfiguration[propertie] = event;
    this.checkErrorsForm[check] =
      this.promoConfiguration[propertie] == null ||
      this.promoConfiguration[propertie].length == 0;
  }

  checkIncludes(propertie: string, check: string) {
    this.checkErrorsForm[check] =
      this.promoConfiguration[propertie] == null ||
      this.promoConfiguration[propertie].length == 0;
  }

  verifyInputText = (str: string, check: string) => {
    this.checkErrorsForm[check] = str == null || str === "" || str.trim() === "";
  }

  verifyPercentPromotion = () => {
    this.checkErrorsForm.inputComisionPromotion =
      this.promoConfiguration.comisionPromotion == null ||
      this.promoConfiguration.comisionPromotion <= 0;
  }

  typeComission(str: string) {
    this.promoConfiguration.typeComission = str === "Fija" ? 0 : 1;
  }

  verifyPercentRefi = () => {
    this.checkErrorsForm.inputAdvantageRefi =
      this.promoConfiguration.advantageRefi == null ||
      this.promoConfiguration.advantageRefi <= 0;
  }

  verifyTasaAnual = () => {
    this.promoConfiguration.tasaAnual =
      Math.round(this.promoConfiguration.tasaAnual * 100) / 100;
    this.checkErrorsForm.inputTasaAnual =
      this.promoConfiguration.tasaAnual == null ||
      this.promoConfiguration.tasaAnual <= 0;
  }

  verifyAge = () => {
    this.checkErrorsForm.inputMinAge =
      this.promoConfiguration.minAge == null || this.promoConfiguration.minAge < 0;
    if (this.promoConfiguration.maxAge == null || this.promoConfiguration.maxAge < 0) {
      this.checkErrorsForm.inputMaxAge = true;
    } else if (this.promoConfiguration.maxAge < this.promoConfiguration.minAge) {
      this.checkErrorsForm.inputMinAge = true;
      this.checkErrorsForm.inputMaxAge = true;
    } else {
      this.checkErrorsForm.inputMinAge = false;
      this.checkErrorsForm.inputMaxAge = false;
    }
  }

  verifyCapitalAmount = () => {
    this.checkErrorsForm.inputMinCapitalAmount =
      this.promoConfiguration.minCapitalAmount == null ||
      this.promoConfiguration.minCapitalAmount < 0;
    if (this.promoConfiguration.maxCapitalAmount == null || this.promoConfiguration.maxCapitalAmount < 0) {
      this.checkErrorsForm.inputMaxCapitalAmount = true;
    } else if (this.promoConfiguration.maxCapitalAmount < this.promoConfiguration.minCapitalAmount) {
      this.checkErrorsForm.inputMinCapitalAmount = true;
      this.checkErrorsForm.inputMaxCapitalAmount = true;
    } else {
      this.checkErrorsForm.inputMinCapitalAmount = false;
      this.checkErrorsForm.inputMaxCapitalAmount = false;
    }
  }

  verifyMountSale = () => {
    this.checkErrorsForm.inputMinValueSale =
      this.promoConfiguration.minValueSale == null ||
      this.promoConfiguration.minValueSale <= 0;
  }

  verifyPercentDiference = () => {
    this.checkErrorsForm.inputPercentDiference =
      this.promoConfiguration.percentDiference == null ||
      this.promoConfiguration.percentDiference <= 0;
  }

  verifyBaseDate = () => {
    let d1 = null, d2 = null;
    const now = Date.now();
    if (this.promoConfiguration.baseInitDate == null) {
      this.checkErrorsForm.inputBaseInitDate = true;
    } else {
      d1 = new Date(this.promoConfiguration.baseInitDate).getTime();
      this.checkErrorsForm.inputBaseInitDate = now < d1;
    }
    if (this.promoConfiguration.baseEndDate == null) {
      this.checkErrorsForm.inputBaseEndDate = true;
    } else {
      d2 = new Date(this.promoConfiguration.baseEndDate).getTime();
      if (now < d2) {
        this.checkErrorsForm.inputBaseEndDate = true;
      } else if (this.promoConfiguration.baseInitDate !== null) {
        if (d1 > d2) {
          this.checkErrorsForm.inputBaseInitDate = true;
          this.checkErrorsForm.inputBaseEndDate = true;
        } else {
          this.checkErrorsForm.inputBaseInitDate = false;
          this.checkErrorsForm.inputBaseEndDate = false;
        }
      }
    }
  }

  verifyCompareDate = () => {
    let d1 = null, d2 = null;
    const now = Date.now();
    if (this.promoConfiguration.compareInitDate == null) {
      this.checkErrorsForm.inputCompareInitDate = true;
    } else {
      d1 = new Date(this.promoConfiguration.compareInitDate).getTime();
      this.checkErrorsForm.inputCompareInitDate = now < d1;
    }
    if (this.promoConfiguration.compareEndDate == null) {
      this.checkErrorsForm.inputCompareEndDate = true;
    } else {
      d2 = new Date(this.promoConfiguration.compareEndDate).getTime();
      if (now < d2) {
        this.checkErrorsForm.inputCompareEndDate = true;
      } else if (this.promoConfiguration.compareInitDate !== null) {
        if (d1 > d2) {
          this.checkErrorsForm.inputCompareInitDate = true;
          this.checkErrorsForm.inputCompareEndDate = true;
        } else {
          this.checkErrorsForm.inputCompareInitDate = false;
          this.checkErrorsForm.inputCompareEndDate = false;
        }
      }
    }
  }

  verifyEffectiveDate = () => {
    console.log("Verificando fechas de vigencia:", this.promoConfiguration.effectiveSince, this.promoConfiguration.effectiveDate);
    if (this.promoConfiguration.effectiveSince == null ||
      this.promoConfiguration.effectiveDate == null) {
      this.checkErrorsForm.inputEffectiveDate = true;
    } else {
      const d1 = new Date(this.promoConfiguration.effectiveSince).getTime();
      const d2 = new Date(this.promoConfiguration.effectiveDate).getTime();
      this.checkErrorsForm.inputEffectiveDate = d1 > d2;
    }
  }

  changePaymentTerm() {
    this.promoConfiguration.paymentTerms = this.plazosCatalog.filter(
      p => p.comission > 0
    );
    this.checkErrorsForm.tooglePaymenTerm = !this.promoConfiguration.paymentTerms.length;
  }

  changeCatoryAsesor(term: any) {
    if (!this.promoConfiguration.categoryAsesor.includes(term)) {
      term.selected = true;
      this.promoConfiguration.categoryAsesor.push(term);
    } else {
      term.selected = false;
      const index = this.promoConfiguration.categoryAsesor.indexOf(term);
      if (index > -1) this.promoConfiguration.categoryAsesor.splice(index, 1);
    }
    this.checkErrorsForm.toogleCategoryAsesor =
      !this.promoConfiguration.categoryAsesor || !this.promoConfiguration.categoryAsesor.length;
  }

  changePaymentCatoryAsesor() {
    const paymentCatRules = this.flat2DArray(
      this.paymentCategoryCatalog.map(p => p.paymentCat)
    ).filter((p: any) => p.comission > 0);

    this.promoConfiguration.paymentTerms = paymentCatRules.map((rule: any) => ({
      id: rule.plazoId,
      name: rule.plazoName,
      categoryId: rule.categoryId,
      categoryName: rule.categoryName,
      comission: rule.comission,
    }));

    const uniqueCategories = Array.from(
      paymentCatRules.reduce((map: any, item: any) => {
        if (!map.has(item.categoryId)) map.set(item.categoryId, item.categoryName);
        return map;
      }, new Map())
    ).map(([id, name]) => ({ id, name }));

    this.promoConfiguration.categoryAsesor = uniqueCategories;
    this.checkErrorsForm.toogleCategoryAsesor = !this.promoConfiguration.categoryAsesor.length;
    this.checkErrorsForm.tooglePaymenTerm = !this.promoConfiguration.paymentTerms.length;
  }

  checkErrorsAlerts(): boolean {
    let flag = true;
    const err = (condition: boolean, msg: string) => {
      if (condition) { this.toastr.error(msg); flag = false; }
    };

    if (this.showConfig.fieldCommissionPromotion) {
      this.verifyPercentPromotion();
    }

    this.checkErrorsForm.inputObservaciones =
      !this.promoConfiguration.observations ||
      this.promoConfiguration.observations.trim() === '';

    err(this.checkErrorsForm.selectedSchema, "No se ha seleccionado ningún schema de promoción");
    err(this.checkErrorsForm.selectedTypeConfiguration, "No se ha seleccionado el tipo de configuración");
    err(this.checkErrorsForm.inputPromotionName, "No se ha ingresado ningún nombre para la nueva promoción");
    err(this.checkErrorsForm.inputEffectiveDate, "No se ha ingresado la fecha de vigencia");
    err(this.showConfig.fieldAsesorType && this.checkErrorsForm.selectedTypeAsesor, "No se ha seleccionado ningún tipo de asesor");
    err(this.showConfig.fieldBusinessLine && this.checkErrorsForm.selectedBusinessLine, "No se ha seleccionado ningún tipo de línea de negocio");
    err(this.showConfig.fieldCommissionPromotion && this.checkErrorsForm.inputComisionPromotion, "No se ha ingresado la comisión");
    err(this.showConfig.fieldGender && this.checkErrorsForm.selectedGender, "No se ha seleccionado ningún género");
    err(this.showConfig.fieldAge && this.checkErrorsForm.inputMinAge, "No se ha ingresado la edad mínima");
    err(this.showConfig.fieldAge && this.checkErrorsForm.inputMaxAge, "No se ha ingresado la edad máxima");
    err(this.showConfig.fieldCivilStatus && this.checkErrorsForm.selectedCivilStatus, "No se ha seleccionado ningún estado civil");
    err(this.showConfig.fieldEmployeeType && this.checkErrorsForm.selectedTypeEmployee, "No se ha seleccionado ningún tipo de empleado");
    err(this.showConfig.fieldSaleType && this.checkErrorsForm.selectedTypeSale, "No se ha seleccionado ningún tipo de venta");
    err(this.showConfig.fieldRefi && this.checkErrorsForm.inputAdvantageRefi, "No se ha ingresado el avance del crédito refinanciado");
    err(this.showConfig.fieldSaleAmount && this.checkErrorsForm.inputMinValueSale, "No se ha ingresado el monto mínimo de venta");
    err(this.showConfig.fieldSaleAmount && this.checkErrorsForm.inputPercentDiference, "No se ha ingresado el porcentaje de diferencia");
    err(this.showConfig.fieldSaleAmount && this.checkErrorsForm.inputBaseInitDate, "No se ha ingresado la fecha inicio del monto base");
    err(this.showConfig.fieldSaleAmount && this.checkErrorsForm.inputBaseEndDate, "No se ha ingresado la fecha fin del monto base");
    err(this.showConfig.fieldSaleAmount && this.checkErrorsForm.inputCompareInitDate, "No se ha ingresado la fecha inicio del monto a comparar");
    err(this.showConfig.fieldSaleAmount && this.checkErrorsForm.inputCompareEndDate, "No se ha ingresado la fecha fin del monto a comparar");
    err(this.showConfig.fieldRegion && this.checkErrorsForm.includeRegion, "No se ha incluido ninguna región");
    err(this.showConfig.fieldState && this.checkErrorsForm.includeEstado, "No se ha incluido ningún estado");
    err(this.showConfig.fieldSucursal && this.checkErrorsForm.includeSucursal, "No se ha incluido ninguna sucursal");
    err(this.showConfig.fieldDependency && this.checkErrorsForm.includeDependencia, "No se ha incluido ninguna dependencia");
    err(this.showConfig.fieldProduct && this.checkErrorsForm.includeProducto, "No se ha incluido ningún producto");
    err(this.showConfig.fieldPaymentTerm && this.checkErrorsForm.tooglePaymenTerm, "No se ha elegido al menos un período de meses");
    err(this.showConfig.fieldCategoryAsesor && this.checkErrorsForm.toogleCategoryAsesor, "No se ha elegido al menos una categoría de asesor");
    err(this.showConfig.fieldCapitalAmount && this.checkErrorsForm.inputMinCapitalAmount, "No se ha ingresado el monto capital mínimo");
    err(this.showConfig.fieldCapitalAmount && this.checkErrorsForm.inputMaxCapitalAmount, "No se ha ingresado el monto capital máximo");
    err(this.showConfig.fieldTasaAnual && this.checkErrorsForm.inputTasaAnual, "No se ha ingresado la tasa anual");
    err(this.showConfig.fieldClavePromocion && this.checkErrorsForm.includeClavePromocion, "No se ha ingresado ninguna clave promoción");
    err(this.showConfig.fieldNuevoCliente && this.checkErrorsForm.selectedNuevoCliente, "No se ha seleccionado el tipo de nuevo cliente");
    err(this.showConfig.fieldAsesor && this.checkErrorsForm.includeAsesor, "No se ha incluido ningún asesor y/o agregado su comisión");
    err(this.showConfig.fieldCommissionPromotion && this.checkErrorsForm.inputComisionPromotion, "No se ha ingresado la comisión");

    return flag;
  }

  selectTypeConfiguration(): void {
    const type = this.promoConfiguration.typeConfiguration ? this.promoConfiguration.typeConfiguration.id : 0;
    this.selectedTypeConfigurationCatalog = [type];
    if (type === 0) {
      this.typeComission('Fija');
      this.showConfig.fieldDatePromoIni = false;
      this.showConfig.fieldDatePromoFin = false;
    } else if (type === 1) {
      this.showConfig.fieldDatePromoIni = true;
      this.showConfig.fieldDatePromoFin = true;
    }
  }

  /* ── Modal de campos ─────────────────────────────────────────── */

  openFieldsModal() {
    this.selectedFieldIds = [];
    this.showFieldsModal = true;
  }

  editFieldsModal() {
    this.selectedFieldIds = (this.promoConfiguration.schema &&
      this.promoConfiguration.schema.campos)
      ? this.promoConfiguration.schema.campos.map((c: any) => c.campoId)
      : [];
    this.showFieldsModal = true;
  }

  onFieldsSelected(campos: any[]) {
    console.log("Campos seleccionados:", campos);
    const camposAnteriores = (this.promoConfiguration.schema &&
      this.promoConfiguration.schema.campos)
      ? this.promoConfiguration.schema.campos.map((c: any) => c.campoId)
      : [];

    const camposNuevos = campos.map((c: any) => c.campoId);
    // Campos que se eliminaron (estaban antes y ya no están)
    const camposEliminados = camposAnteriores.filter(id => camposNuevos.indexOf(id) === -1);
    // Campos que se agregaron (no estaban antes y ahora sí)
    const camposAgregados = camposNuevos.filter(id => camposAnteriores.indexOf(id) === -1);
    console.log("Campos anteriores:", camposAnteriores);
    console.log("Campos nuevos:", camposNuevos);
    console.log("Campos eliminados:", camposEliminados);
    // Actualizar schema
    this.promoConfiguration.schema = {
      promotionSchemaId: this.promoConfiguration.schema
        ? this.promoConfiguration.schema.promotionSchemaId
        : null,
      promotionSchemaName: this.promoConfiguration.promotionName
        ? this.promoConfiguration.promotionName.trim() + '_ESTRUCTURA'
        : 'NUEVA ESTRUCTURA',
      campos: campos,
      fields: campos
    };
    this.selectedFieldIds = camposNuevos;

    // ── Reconstruir showConfig desde cero ──────────────────────────
    this.showConfig = {
      fieldRegion: false, fieldState: false, fieldSucursal: false,
      fieldAsesorType: false, fieldCategoryAsesor: false, fieldDependency: false,
      fieldProduct: false, fieldPaymentTerm: false, fieldSaleAmount: false,
      fieldRefi: false, fieldSaleType: false, fieldGender: false, fieldAge: false,
      fieldCivilStatus: false, fieldBusinessLine: false, fieldEmployeeType: false,
      fieldCapitalAmount: false, fieldCommissionPromotion: true, fieldTasaAnual: false,
      fieldClavePromocion: false, fieldNuevoCliente: false, fieldAsesor: false,
      fieldDatePromoIni: false, fieldDatePromoFin: false, fieldMontoObjetivo: false
    };

    // Activar showConfig para todos los campos nuevos
    camposNuevos.forEach(id => this.activarCampoPorId(id));
    // ── Limpiar solo los campos eliminados ─────────────────────────
    camposEliminados.forEach(id => this.limpiarCampoPorId(id));

    // ── Activar alertas SOLO para campos nuevos ─────────────────────
    // Los campos que ya existían conservan su estado de alerta actual
    camposAgregados.forEach(id => this.activarCheckErrorPorId(id));

    // Activar alertas solo para campos que están en la nueva selección
    // camposNuevos.forEach(id => this.activarCheckErrorPorId(id));

    // Desactivar alertas para campos que ya tienen valor
    this.desactivarAlertas();
    this.checkErrorsForm.selectedSchema = campos.length === 0;

    // ── Fallbacks ───────────────────────────────────────────────────
    if (!this.showConfig.fieldRegion) {
      this.promoConfiguration.region = [...this.regionCatalog];
    }
    if (!this.showConfig.fieldAsesorType) {
      this.promoConfiguration.typeAsesor = [...this.employeeJobCatalog];
    }
    if (!this.showConfig.fieldBusinessLine) {
      this.promoConfiguration.businessLine = [...this.businessProductCatalog];
    }

    if (!this.showConfig.fieldState) {
      this.promoConfiguration.estado = [];
    }
    if (!this.showConfig.fieldSucursal) {
      this.promoConfiguration.sucursal = [];
    }

    if (!this.showConfig.fieldProduct) {
      this.promoConfiguration.producto = [];
    }

    if (!this.showConfig.fieldDependency) {
      this.promoConfiguration.dependencia = [];
    }

    this.selectRegion();
    this.selectTypeAsesor();
    this.selectBussinesLine();
    this.showFieldsModal = false;
  }

  onFieldsModalClosed(reason: string) {
    this.showFieldsModal = false;
  }

  /* ── Métodos privados ────────────────────────────────────────── */

  private activarCampoPorId(campoId: number) {
    const mapa: { [key: number]: () => void } = {
      1: () => { this.showConfig.fieldRegion = true; },
      2: () => { this.showConfig.fieldState = true; },
      3: () => { this.showConfig.fieldSucursal = true; },
      4: () => { this.showConfig.fieldAsesorType = true; },
      5: () => { this.showConfig.fieldCategoryAsesor = true; },
      6: () => { this.showConfig.fieldDependency = true; },
      7: () => { this.showConfig.fieldProduct = true; },
      8: () => {
        this.showConfig.fieldPaymentTerm = true;
        this.showConfig.fieldCommissionPromotion = false;
        this.placeholderCommission = 'Por plazos';
      },
      9: () => { this.showConfig.fieldSaleAmount = true; },
      11: () => { this.showConfig.fieldRefi = true; },
      12: () => { this.showConfig.fieldSaleType = true; },
      13: () => { this.showConfig.fieldGender = true; },
      14: () => { this.showConfig.fieldAge = true; },
      15: () => { this.showConfig.fieldCivilStatus = true; },
      16: () => { this.showConfig.fieldEmployeeType = true; },
      17: () => { this.showConfig.fieldBusinessLine = true; },
      18: () => { this.showConfig.fieldCapitalAmount = true; },
      19: () => { this.showConfig.fieldTasaAnual = true; },
      20: () => { this.showConfig.fieldClavePromocion = true; },
      21: () => { this.showConfig.fieldNuevoCliente = true; },
      22: () => {
        this.showConfig.fieldAsesor = true;
        this.checkErrorsForm.includeAsesor = true;
      },
    };
    const fn = mapa[campoId];
    if (fn) fn();
    else console.warn(`campoId no reconocido: ${campoId}`);
  }

  private activarCheckErrorPorId(campoId: number) {
    const mapa: { [key: number]: () => void } = {
      1: () => { this.checkErrorsForm.includeRegion = true; },
      2: () => { this.checkErrorsForm.includeEstado = true; },
      3: () => { this.checkErrorsForm.includeSucursal = true; },
      4: () => { this.checkErrorsForm.selectedTypeAsesor = true; },
      5: () => { this.checkErrorsForm.toogleCategoryAsesor = true; },
      6: () => { this.checkErrorsForm.includeDependencia = true; },
      7: () => { this.checkErrorsForm.includeProducto = true; },
      8: () => {
        this.checkErrorsForm.tooglePaymenTerm = true;
        this.checkErrorsForm.inputComisionPromotion = false;
        this.promoConfiguration.comisionPromotion = null;
      },
      9: () => {
        this.checkErrorsForm.inputMinValueSale = true;
        this.checkErrorsForm.inputPercentDiference = true;
        this.checkErrorsForm.inputBaseInitDate = true;
        this.checkErrorsForm.inputBaseEndDate = true;
        this.checkErrorsForm.inputCompareInitDate = true;
        this.checkErrorsForm.inputCompareEndDate = true;
      },
      11: () => { this.checkErrorsForm.inputAdvantageRefi = true; },
      12: () => { this.checkErrorsForm.selectedTypeSale = true; },
      13: () => { this.checkErrorsForm.selectedGender = true; },
      14: () => {
        this.checkErrorsForm.inputMinAge = true;
        this.checkErrorsForm.inputMaxAge = true;
      },
      15: () => { this.checkErrorsForm.selectedCivilStatus = true; },
      16: () => { this.checkErrorsForm.selectedTypeEmployee = true; },
      17: () => { this.checkErrorsForm.selectedBusinessLine = true; },
      18: () => {
        this.checkErrorsForm.inputMinCapitalAmount = true;
        this.checkErrorsForm.inputMaxCapitalAmount = true;
      },
      19: () => { this.checkErrorsForm.inputTasaAnual = true; },
      20: () => { this.checkErrorsForm.includeClavePromocion = true; },
      21: () => { this.checkErrorsForm.selectedNuevoCliente = true; },
      22: () => { this.checkErrorsForm.includeAsesor = true; },
    };
    const fn = mapa[campoId];
    if (fn) fn();
  }

  private limpiarCampoPorId(campoId: number) {
    const mapa: { [key: number]: () => void } = {
      1: () => { this.promoConfiguration.region = []; this.selectedPromotionSchemaCatalog = []; },
      2: () => { this.promoConfiguration.estado = []; },
      3: () => { this.promoConfiguration.sucursal = []; },
      4: () => {
        this.promoConfiguration.typeAsesor = [];
        this.selectedEmployeeJobCatalog = [];
      },
      5: () => {
        this.promoConfiguration.categoryAsesor = [];
        this.categoriesCatalog = this.categoriesCatalog.map(c => ({ ...c, selected: false }));
      },
      6: () => { this.promoConfiguration.dependencia = []; },
      7: () => { this.promoConfiguration.producto = []; },
      8: () => {
        this.promoConfiguration.paymentTerms = [];
        this.plazosCatalog = this.plazosCatalog.map(p => ({ ...p, comission: 0 }));
        this.paymentCategoryCatalog = [];
        this.showConfig.fieldCommissionPromotion = true;
        this.placeholderCommission = 'Ingresa comisión...';
      },
      9: () => {
        this.promoConfiguration.minValueSale = 0;
        this.promoConfiguration.percentDiference = 0;
        this.promoConfiguration.baseInitDate = null;
        this.promoConfiguration.baseEndDate = null;
        this.promoConfiguration.compareInitDate = null;
        this.promoConfiguration.compareEndDate = null;
      },
      11: () => { this.promoConfiguration.advantageRefi = 0; },
      12: () => {
        this.promoConfiguration.typeSale = [];
        this.selectedTypeSaleCatalog = [];
      },
      13: () => {
        this.promoConfiguration.gender = [];
        this.selectedGenderCatalog = [];
      },
      14: () => {
        this.promoConfiguration.minAge = 0;
        this.promoConfiguration.maxAge = 100;
      },
      15: () => {
        this.promoConfiguration.civilStatus = [];
        this.selectedCivilStatusCatalog = [];
      },
      16: () => {
        this.promoConfiguration.typeEmployee = [];
        this.selectedTypeEmployeeCatalog = [];
      },
      17: () => {
        this.promoConfiguration.businessLine = [];
        this.selectedBusinessProductCatalog = [];
      },
      18: () => {
        this.promoConfiguration.minCapitalAmount = 0;
        this.promoConfiguration.maxCapitalAmount = 10000000;
      },
      19: () => { this.promoConfiguration.tasaAnual = 0; },
      20: () => {
        this.promoConfiguration.clavePromocion = [];
      },
      21: () => {
        this.promoConfiguration.nuevoCliente = [];
        this.selectedNuevoClienteCatalog = [];
      },
      22: () => {
        this.promoConfiguration.asesores = [];
        this.asesorViewCatalog = [];
        this.asesorCatalog = [];
      },
    };
    const fn = mapa[campoId];
    if (fn) fn();
  }

  private desactivarAlertas() {
    // Desactivar alertas de campos que ya tienen datos válidos
    if (this.promoConfiguration.typeAsesor && this.promoConfiguration.typeAsesor.length > 0) {
      this.checkErrorsForm.selectedTypeAsesor = false;
    }
    if (this.promoConfiguration.businessLine && this.promoConfiguration.businessLine.length > 0) {
      this.checkErrorsForm.selectedBusinessLine = false;
    }
    if (this.promoConfiguration.gender && this.promoConfiguration.gender.length > 0) {
      this.checkErrorsForm.selectedGender = false;
    }
    if (this.promoConfiguration.civilStatus && this.promoConfiguration.civilStatus.length > 0) {
      this.checkErrorsForm.selectedCivilStatus = false;
    }
    if (this.promoConfiguration.typeEmployee && this.promoConfiguration.typeEmployee.length > 0) {
      this.checkErrorsForm.selectedTypeEmployee = false;
    }
    if (this.promoConfiguration.typeSale && this.promoConfiguration.typeSale.length > 0) {
      this.checkErrorsForm.selectedTypeSale = false;
    }
    if (this.promoConfiguration.nuevoCliente && this.promoConfiguration.nuevoCliente.length > 0) {
      this.checkErrorsForm.selectedNuevoCliente = false;
    }
    if (this.promoConfiguration.region && this.promoConfiguration.region.length > 0) {
      this.checkErrorsForm.includeRegion = false;
    }
    if (this.promoConfiguration.estado && this.promoConfiguration.estado.length > 0) {
      this.checkErrorsForm.includeEstado = false;
    }
    if (this.promoConfiguration.sucursal && this.promoConfiguration.sucursal.length > 0) {
      this.checkErrorsForm.includeSucursal = false;
    }
    if (this.promoConfiguration.dependencia && this.promoConfiguration.dependencia.length > 0) {
      this.checkErrorsForm.includeDependencia = false;
    }
    if (this.promoConfiguration.producto && this.promoConfiguration.producto.length > 0) {
      this.checkErrorsForm.includeProducto = false;
    }
    if (this.promoConfiguration.paymentTerms && this.promoConfiguration.paymentTerms.length > 0) {
      this.checkErrorsForm.tooglePaymenTerm = false;
    }
    if (this.promoConfiguration.categoryAsesor && this.promoConfiguration.categoryAsesor.length > 0) {
      this.checkErrorsForm.toogleCategoryAsesor = false;
    }
    if (this.promoConfiguration.clavePromocion && this.promoConfiguration.clavePromocion.length > 0) {
      this.checkErrorsForm.includeClavePromocion = false;
    }
    if (this.promoConfiguration.asesores && this.promoConfiguration.asesores.length > 0) {
      this.checkErrorsForm.includeAsesor = false;
    }
    if (this.promoConfiguration.comisionPromotion != null && this.promoConfiguration.comisionPromotion > 0) {
      this.checkErrorsForm.inputComisionPromotion = false;
    }
    if (this.promoConfiguration.advantageRefi != null && this.promoConfiguration.advantageRefi > 0) {
      this.checkErrorsForm.inputAdvantageRefi = false;
    }
    if (this.promoConfiguration.minAge != null && this.promoConfiguration.minAge >= 0) {
      this.checkErrorsForm.inputMinAge = false;
    }
    if (this.promoConfiguration.maxAge != null && this.promoConfiguration.maxAge > 0) {
      this.checkErrorsForm.inputMaxAge = false;
    }
    if (this.promoConfiguration.tasaAnual != null && this.promoConfiguration.tasaAnual > 0) {
      this.checkErrorsForm.inputTasaAnual = false;
    }
    if (this.promoConfiguration.minCapitalAmount != null && this.promoConfiguration.minCapitalAmount >= 0) {
      this.checkErrorsForm.inputMinCapitalAmount = false;
    }
    if (this.promoConfiguration.maxCapitalAmount != null && this.promoConfiguration.maxCapitalAmount > 0) {
      this.checkErrorsForm.inputMaxCapitalAmount = false;
    }
  }

  getToday(): string {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getDateAddDays(days: number): string {
    const d = new Date();
    d.setDate(d.getDate() + days);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  toogleVigenciaEditable = () => {
    this.vigenciaEditable = !this.vigenciaEditable;
    if (!this.vigenciaEditable) {
      this.promoConfiguration.effectiveDate = this.getDateAddDays(30);
      this.promoConfiguration.effectiveSince = this.getToday();
      this.verifyEffectiveDate();
    }
  }

  addThirtyDays(): void {
    // ← Parsear como fecha local, no UTC
    const partes = this.promoConfiguration.effectiveDate.split('-');
    const d = new Date(
      parseInt(partes[0], 10),
      parseInt(partes[1], 10) - 1,
      parseInt(partes[2], 10)
    );
    d.setDate(d.getDate() + 30);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    this.promoConfiguration.effectiveDate = `${year}-${month}-${day}`;
  }

  editableBoolean = () => this.mode === "edit";

  toggleSection(section: string) {
    this.sectionOpen[section] = !this.sectionOpen[section];
  }

  selectRegion() {
    console.log('=== DENTRO DE selectRegion ===');
    console.log('region:', this.promoConfiguration.region);
    console.log('estado antes:', this.promoConfiguration.estado);
    console.log('fieldState:', this.showConfig.fieldState);
    console.log('fieldRegion:', this.showConfig.fieldRegion);

    const states = [];
    this.promoConfiguration.region.forEach(region => {
      states.push(this.stateCatalog.filter(state => region._id == state._regionId));
    });
    this.stateViewCatalog = this.flat2DArray(states);

    console.log('stateViewCatalog generado:', this.stateViewCatalog.map(s => s._name));

    if (this.showConfig.fieldState) {
      this.promoConfiguration.estado = this.promoConfiguration.estado.filter(
        e => this.stateViewCatalog.some(s => s._id === e._id)
      );
    } else {
      this.promoConfiguration.estado = [...this.stateViewCatalog];
    }

    this.selectState();
    console.log('estado después:', this.promoConfiguration.estado);
  }

  selectState() {
    const sucursales = [];
    this.promoConfiguration.estado.forEach(estado => {
      sucursales.push(this.sucursalCatalog.filter(s => estado._id == s._estadoId));
    });
    this.sucursalViewCatalog = this.flat2DArray(sucursales);

    if (this.showConfig.fieldSucursal) {
      this.promoConfiguration.sucursal = this.promoConfiguration.sucursal.filter(
        s => this.sucursalViewCatalog.some(sv => sv._id === s._id)
      );
    } else {
      // ← Siempre recalcular, no solo cuando está vacío
      this.promoConfiguration.sucursal = [...this.sucursalViewCatalog];
    }
  }

  selectTypeAsesor() {
    const categories = [];
    this.promoConfiguration.typeAsesor.forEach(type => {
      categories.push(this.categoriesCatalog.filter(c => type.id == c.fatherId));
    });
    this.categoriesViewCatalog = this.flat2DArray(categories);
    const ids = this.categoriesViewCatalog.map(c => c.id).filter((v, i, a) => a.indexOf(v) === i);
    this.categoriesViewCatalog = ids.map(id => this.categoriesViewCatalog.find(c => c.id == id));
    this.promoConfiguration.categoryAsesor = this.categoriesViewCatalog.filter(c => c.selected);

    this.paymentCategoryCatalog = this.plazosCatalog.map(plazo => ({
      plazoName: plazo.name,
      paymentCat: this.categoriesViewCatalog.map(category => ({
        plazoId: plazo.id,
        plazoName: plazo.name,
        categoryId: category.id,
        categoryName: category.name,
        comission: this.findCommission(plazo.id, category.id),
      }))
    }));

    if (this.showConfig.fieldPaymentTerm && this.showConfig.fieldCategoryAsesor) {
      this.changePaymentCatoryAsesor();
    }
  }

  findCommission(plazoId: any, categoryId: any): number {
    if (!this.paymentCategoryCatalog.length) return 0;
    const rules = this.flat2DArray(this.paymentCategoryCatalog.map(p => p.paymentCat))
      .filter((p: any) => p.comission > 0 && p.plazoId == plazoId && p.categoryId == categoryId);
    return rules.length ? rules[0].comission : 0;
  }

  selectBussinesLine() {
    // Producto es catálogo local: identidad únicamente por _id_int, nunca por core.
    const products = [];
    this.promoConfiguration.businessLine.forEach(line => {
      products.push(this.productCatalog.filter(
        product => Number(line.id) === Number(product._bussinesLineId)
      ));
    });
    this.productViewCatalog = this.flat2DArray(products);
    const ids = this.productViewCatalog.map(p => p._id_int).filter((v, i, a) => a.indexOf(v) === i);
    this.productViewCatalog = ids.map(id => this.productViewCatalog.find(p => p._id_int == id));

    if (this.showConfig.fieldProduct) {
      this.promoConfiguration.producto = this.promoConfiguration.producto.filter(selected =>
        this.productViewCatalog.some(
          available => Number(available._id_int) === Number(selected._id_int)
        )
      );
    } else {
      this.promoConfiguration.producto = [...this.productViewCatalog];
    }
    this.selectProduct();
  }

  selectProduct() {
    const dependencies = [];
    this.promoConfiguration.producto.forEach(product => {
      dependencies.push(this.dependenciesCatalog.filter(
        d => product._id_int == d._productId && product.core == d.core
      ));
    });
    this.dependenciesViewCatalog = this.flat2DArray(dependencies);
    const ids = this.dependenciesViewCatalog.map(d => d._id_int).filter((v, i, a) => a.indexOf(v) === i);
    this.dependenciesViewCatalog = ids.map(id =>
      this.dependenciesViewCatalog.find(d => d._id_int == id)
    );
    this.promoConfiguration.dependencia = this.promoConfiguration.dependencia.filter(d =>
      this.dependenciesViewCatalog.some(dv => dv._id_int == d._id_int && dv.core == d.core)
    );

    if (this.showConfig.fieldDependency) {
      this.promoConfiguration.dependencia = this.promoConfiguration.dependencia.filter(d =>
        this.dependenciesViewCatalog.some(dv => dv._id_int == d._id_int && dv.core == d.core)
      );
    } else {
      this.promoConfiguration.dependencia = [...this.dependenciesViewCatalog];
    }
  }

  private flat2DArray(arr: any[][]): any[] {
    const elements = [];
    arr.forEach(sub => sub.forEach(el => elements.push(el)));
    return elements;
  }

  formatAsesorNumber(): string {
    if (!this.tempAsesorNumber || !this.tempAsesorNumber.trim()) return '';
    return this.tempAsesorNumber.replace(/\s+/g, '').toUpperCase().padStart(5, '0');
  }

  addAsesor() {
    if (!this.tempAsesorNumber || !this.tempAsesorNumber.trim()) {
      this.toastr.warning('Ingresa un número de asesor válido');
      return;
    }
    const formattedNumber = this.formatAsesorNumber();
    if (this.asesorViewCatalog.some(a => a.number === formattedNumber)) {
      this.toastr.warning('Este asesor ya ha sido agregado');
      return;
    }
    const newAsesor = {
      id: this.asesorViewCatalog.length + 1,
      number: formattedNumber,
      name: `Asesor ${this.tempAsesorNumber.trim()}`,
      amount: this.showConfig.fieldPaymentTerm ? null : 0,
      plazos: this.showConfig.fieldPaymentTerm
        ? this.plazosCatalog.map(p => ({ plazoId: p.id, plazoName: p.name, amount: 0 }))
        : null
    };
    this.asesorViewCatalog.push(newAsesor);
    this.asesorCatalog.push(newAsesor);
    this.tempAsesorNumber = '';
    this.updateAsesoresConfiguration();
  }

  removeAsesor(asesor: any) {
    const index = this.asesorViewCatalog.findIndex(a => a.id === asesor.id);
    if (index > -1) {
      this.asesorViewCatalog.splice(index, 1);
      const ci = this.asesorCatalog.findIndex(a => a.id === asesor.id);
      if (ci > -1) this.asesorCatalog.splice(ci, 1);
      this.updateAsesoresConfiguration();
    }
  }

  updateAsesoresConfiguration() {
    if (this.showConfig.fieldPaymentTerm) {
      this.promoConfiguration.asesores = this.asesorViewCatalog.reduce(
        (acc, asesor) => acc.concat(
          asesor.plazos
            .filter((p: any) => p.amount > 0)
            .map((p: any) => ({
              asesorId: asesor.number,
              plazoId: p.plazoId,
              plazoName: p.plazoName,
              comission: p.amount
            }))
        ), []
      );
    } else {
      this.promoConfiguration.asesores = this.asesorViewCatalog
        .filter(a => a.amount > 0)
        .map(a => ({
          asesorId: a.number,
          plazoId: null,
          plazoName: null,
          comission: a.amount
        }));
    }
    this.checkErrorsForm.includeAsesor =
      !this.promoConfiguration.asesores || !this.promoConfiguration.asesores.length;
  }

  changeAsesor() { this.updateAsesoresConfiguration(); }
  changeAsesorPayment() { this.updateAsesoresConfiguration(); }
  selectAsesores() { this.checkIncludes('asesores', 'includeAsesor'); }

  agregarMeta() {
    if (!this.metaForm.fechaInicio || !this.metaForm.fechaFin || !this.metaForm.fechaCorte || !this.metaForm.objetivo) {
      this.toastr.warning('Completa todos los campos de la meta');
      return;
    }
    // Modo edición de la configuración
    if (this.isEditMode) {
      // ── Modo edición: guardar directo en backend ──────────────
      const meta: MetaPromocion = {
        catPromotionId: this.promotionId,
        fechaInicio: this.metaForm.fechaInicio,
        fechaFin: this.metaForm.fechaFin,
        fechaCorte: this.metaForm.fechaCorte,
        objetivo: this.metaForm.objetivo,
        comisiones: [],
        filtro: null,
      };
      this.commissionPromotionsService
        .crearMeta(this.promotionId, meta)
        .subscribe(
          (resp) => {
            if (resp.httpStatusCode === 200) {
              this.toastr.success('Meta creada correctamente');
              this.metasCatalog.push({
                ...meta,
                metaPromocionId: resp.data.metaPromocionId
              });
              this.resetMetaForm();
              this.showMetaForm = false;
            } else {
              this.toastr.error('Error al crear la meta');
            }
          },
          (error) => {
            console.error(error);
            this.toastr.error('Error al crear la meta');
          }
        );
    } else {
      // ── Modo creación: guardar localmente ─────────────────────
      const metaLocal: MetaPromocion = {
        metaPromocionId: this.metaIdCounter--,  // ID temporal negativo
        fechaInicio: this.metaForm.fechaInicio,
        fechaFin: this.metaForm.fechaFin,
        fechaCorte: this.metaForm.fechaCorte,
        objetivo: this.metaForm.objetivo,
        comisiones: [],
        filtro: null,
      };
      this.metasCatalog.push(metaLocal);
      this.toastr.info('Meta agregada, se guardará al confirmar la configuración');
      this.resetMetaForm();
      this.showMetaForm = false;
    }
  }

  editarMeta(meta: any): void {
    this.metaSeleccionada = meta;
    this.metaComisionesExistentes = meta.comisiones || [];

    // ← Extraer comisionMeta desde las comisiones existentes
    let comisionMeta = null;
    if (meta.comisiones && meta.comisiones.length) {
      // Caso sin plazos ni categorías: un registro con ambos null
      const sinPlazosSinCats = meta.comisiones.find(
        (c: any) => c.plazoValor === null && c.categoriaAsesorId === null && c.empleado === null
      );
      // Caso solo categorías: tomar la comisión del primer registro
      const soloCategoria = meta.comisiones.find(
        (c: any) => c.plazoValor === null && c.categoriaAsesorId !== null
      );

      if (sinPlazosSinCats) {
        comisionMeta = sinPlazosSinCats.comision;
      } else if (soloCategoria) {
        comisionMeta = soloCategoria.comision;
      }
    }

    // ← Inyectar en metaForm para que el hijo lo reciba
    this.metaForm = {
      metaPromocionId: meta.metaPromocionId,
      fechaInicio: meta.fechaInicio,
      fechaFin: meta.fechaFin,
      fechaCorte: meta.fechaCorte,
      objetivo: meta.objetivo,
      comisionMeta: comisionMeta,   // ← NUEVO
    };

    this.showMetaForm = true;
  }


  guardarEdicionMeta() {
    if (!this.metaForm.fechaInicio || !this.metaForm.fechaFin || !this.metaForm.fechaCorte || !this.metaForm.objetivo) {
      this.toastr.warning('Completa todos los campos de la meta');
      return;
    }

    const metaActualizada: MetaPromocion = {
      ...this.metaSeleccionada,
      fechaInicio: this.metaForm.fechaInicio,
      fechaFin: this.metaForm.fechaFin,
      fechaCorte: this.metaForm.fechaCorte,
      objetivo: this.metaForm.objetivo,
    };

    if (this.isEditMode && this.metaForm.metaPromocionId > 0) {
      // ── Meta real en backend ──────────────────────────────────
      this.commissionPromotionsService
        .editarMeta(this.promotionId, this.metaForm.metaPromocionId, metaActualizada)
        .subscribe(
          (resp) => {
            if (resp.httpStatusCode === 200) {
              this.toastr.success('Meta actualizada correctamente');
              const idx = this.metasCatalog.findIndex(
                m => m.metaPromocionId === this.metaForm.metaPromocionId
              );
              if (idx !== -1) this.metasCatalog[idx] = { ...metaActualizada };
              this.resetMetaForm();
              this.showMetaForm = false;
            } else {
              this.toastr.error('Error al editar la meta');
            }
          },
          (error) => {
            console.error(error);
            this.toastr.error('Error al editar la meta');
          }
        );
    } else {
      // ── Meta local (creación o meta nueva en edición) ─────────
      const idx = this.metasCatalog.findIndex(
        m => m.metaPromocionId === this.metaForm.metaPromocionId
      );
      if (idx !== -1) this.metasCatalog[idx] = { ...metaActualizada };
      this.resetMetaForm();
      this.showMetaForm = false;
    }
  }

  eliminarMeta(meta: MetaPromocion) {
    Swal.fire({
      title: '¿Eliminar esta meta?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        if (this.isEditMode && meta.metaPromocionId > 0) {
          // ── Meta real: eliminar en backend ────────────────────
          this.commissionPromotionsService
            .eliminarMeta(this.promotionId, meta.metaPromocionId)
            .subscribe(
              (resp) => {
                if (resp.httpStatusCode === 200) {
                  this.toastr.success('Meta eliminada correctamente');
                  Swal.fire({
                    title: 'Meta eliminada correctamente',
                    text: 'La meta ha sido eliminada exitosamente',
                    icon: 'success',
                    confirmButtonText: 'Confirmar'
                  });
                  this.metasCatalog = this.metasCatalog.filter(
                    m => m.metaPromocionId !== meta.metaPromocionId
                  );
                } else {
                  Swal.fire({
                    title: 'Error al eliminar la meta!',
                    text: resp.messageError || 'Ocurrió un error inesperado',
                    icon: 'error',
                    confirmButtonText: 'Confirmar'
                  });
                  this.toastr.error('Error al eliminar la meta');
                }
              },
              (error) => {
                console.error(error);
                this.toastr.error('Error al eliminar la meta');
              }
            );
        } else {
          // ── Meta local: eliminar del arreglo ──────────────────
          this.metasCatalog = this.metasCatalog.filter(
            m => m.metaPromocionId !== meta.metaPromocionId
          );
          this.toastr.info('Meta eliminada');
        }
      }
    });
  }

  resetMetaForm() {
    this.metaForm = {
      metaPromocionId: null,
      fechaInicio: this.getToday(),
      fechaFin: this.getToday(),
      fechaCorte: this.getToday(),
      objetivo: null,
      comisionMeta: null,
    };
    this.metaSeleccionada = null;
    this.metaComisionesExistentes = [];
  }

  cancelarMetaForm() {
    this.resetMetaForm();
    this.showMetaForm = false;
  }

  onMetaGuardada(payload: any): void {
    const { metaForm, metaComisiones, metaConfiguration, metaSchema,
      metaShowConfig, metaPlazosCatalog, metaPaymentCategoryCatalog,
      metaCategoriesView } = payload;
    const userId = parseInt(localStorage.getItem('UserId') || '0', 10);

    // ── Helper: construir filtro en formato backend para guardado local ──
    const buildFiltroLocal = (): any => {
      if (!metaSchema) return null;

      // ← Construir listPlazo según combinación de campos de la meta
      const listPlazo: any[] = (() => {
        if (metaShowConfig.fieldPaymentTerm && metaShowConfig.fieldCategoryAsesor) {
          const result = [];
          (metaPaymentCategoryCatalog || []).forEach((row: any) => {
            row.paymentCat
              .filter((cell: any) => (cell.comission || 0) > 0)
              .forEach((cell: any) => result.push({
                plazoId: cell.plazoId,
                plazoValor: String(row.plazoName),
                categoriaId: cell.categoryId,
                comision: cell.comission || 0,
              }));
          });
          return result;
        } else if (metaShowConfig.fieldPaymentTerm && !metaShowConfig.fieldCategoryAsesor) {
          return (metaPlazosCatalog || [])
            .filter((p: any) => (p.comission || 0) > 0)
            .map((p: any) => ({
              plazoId: p.id,
              plazoValor: String(p.name),
              categoriaId: null,
              comision: p.comission || 0,
            }));
        }
        return [];
      })();

      // ← Construir listCategoriaAsesor según combinación
      const listCategoriaAsesor: any[] = (() => {
        if (metaShowConfig.fieldCategoryAsesor && !metaShowConfig.fieldPaymentTerm) {
          return (metaCategoriesView || [])
            .filter((c: any) => c.selected)
            .map((c: any) => ({
              categoriaAsesorId: c.id,
              categoriaAsesorValor: c.name || c.description || '',
            }));
        } else if (metaShowConfig.fieldCategoryAsesor && metaShowConfig.fieldPaymentTerm) {
          // ← Extraer categorías únicas de los plazos seleccionados
          const cats = new Map();
          (metaPaymentCategoryCatalog || []).forEach((row: any) => {
            row.paymentCat
              .filter((cell: any) => (cell.comission || 0) > 0)
              .forEach((cell: any) => {
                if (!cats.has(cell.categoryId)) {
                  cats.set(cell.categoryId, cell.categoryName);
                }
              });
          });
          return Array.from(cats.entries()).map(([id, name]) => ({
            categoriaAsesorId: id,
            categoriaAsesorValor: name,
          }));
        }
        return (metaConfiguration.categoryAsesor || []).map((c: any) => ({
          categoriaAsesorId: c.id,
          categoriaAsesorValor: c.name || c.description || '',
        }));
      })();

      return {
        estructura: {
          estructuraId: metaSchema.promotionSchemaId || null,
          nombreEstructura: metaSchema.promotionSchemaName || '',
          campos: (metaSchema.campos || []).map((c: any) => ({
            campoId: c.campoId,
            nombreCampo: c.nombreCampo,
            activoId: c.activoId || 1,
            usuarioId: c.usuarioId || 0,
            fechaCreacion: c.fechaCreacion || null,
          })),
        },
        listTipoAsesor: (metaConfiguration.typeAsesor || [])
          .map((e: any) => ({ tipoAsesorId: e.id, tipoAsesorValor: e.description })),
        listLineaNegocio: (metaConfiguration.businessLine || [])
          .map((e: any) => ({ lineaNegocioId: e.id, lineaNegocioValor: e.description, core: e.core })),
        listGenero: (metaConfiguration.gender || [])
          .map((e: any) => ({ generoId: e.id, generoValor: e.description })),
        listEdad: (metaConfiguration.minAge > 0 || metaConfiguration.maxAge < 100)
          ? [{ edadMinima: metaConfiguration.minAge, edadMaxima: metaConfiguration.maxAge }] : [],
        listEstadoCivil: (metaConfiguration.civilStatus || [])
          .map((e: any) => ({ estadoCivilId: e.id, estadoCivilValor: e.description, core: e.core })),
        listTipoEmpleado: (metaConfiguration.typeEmployee || [])
          .map((e: any) => ({ tipoEmpleadoId: e.id, tipoEmpleadoValor: e.description, core: e.core })),
        listTipoVenta: (metaConfiguration.typeSale || [])
          .map((e: any) => ({ tipoVentaId: e.id, tipoVentaValor: e.description })),
        listNuevoCliente: (metaConfiguration.nuevoCliente || [])
          .map((e: any) => ({ nuevoClienteId: e.id, nuevoClienteValor: e.description })),
        listRegion: (metaConfiguration.region || [])
          .map((e: any) => ({ regionId: e._id, regionValor: e._name })),
        listEstado: (metaConfiguration.estado || [])
          .map((e: any) => ({ estadoId: e._id, estadoValor: e._name })),
        listSucursal: (metaConfiguration.sucursal || [])
          .map((e: any) => ({ sucursalId: e._id, sucursalValor: e._name })),
        listProducto: (metaConfiguration.producto || [])
          .map((e: any) => ({ productoId: e._id_int, productoValor: e._name, core: e.core })),
        listDependencia: (metaConfiguration.dependencia || [])
          .map((e: any) => ({ dependenciaId: e._id_int, dependenciaValor: e._name, core: e.core })),
        listClavePromocion: (metaConfiguration.clavePromocion || [])
          .map((e: any) => ({ clavePromocionId: e._id_int })),
        listMontoCapital: (metaShowConfig.fieldCapitalAmount)
          ? [{
            montoCapitalMinimo: metaConfiguration.minCapitalAmount,
            montoCapitalMaximo: metaConfiguration.maxCapitalAmount
          }] : [],
        listTasaAnual: metaConfiguration.tasaAnual > 0
          ? [{ tasaAnual: metaConfiguration.tasaAnual }] : [],
        listCategoriaAsesor: listCategoriaAsesor,
        listPlazo: listPlazo,
        listMontoVenta: [],
        listRefis: [],
        listPagoAsesor: [],
      };
    };

    if (this.isEditMode) {
      if (metaForm.metaPromocionId && metaForm.metaPromocionId > 0) {

        // ── Actualizar meta existente ─────────────────────────────
        const metaActualizada: MetaPromocion = {
          metaPromocionId: metaForm.metaPromocionId,
          catPromotionId: this.promotionId,
          nombrePromocion: this.promoConfiguration.promotionName || '',
          fechaInicio: metaForm.fechaInicio,
          fechaFin: metaForm.fechaFin,
          fechaCorte: metaForm.fechaCorte,
          objetivo: metaForm.objetivo,
          activa: metaForm.activa,
          comisiones: metaComisiones || [],
          filtro: metaConfiguration || null,
        };
        console.log('Meta actualizada a guardar:', metaActualizada);
        
        this.commissionPromotionsService
        .editarMeta(this.promotionId, metaForm.metaPromocionId, metaActualizada)
        .pipe(
          switchMap((resp) => {
            if (resp.httpStatusCode !== 200) return of(resp);
            const filtro = metaActualizada.filtro;
            if (filtro && this.commissionPromotionsService.filtroTieneDatos(filtro)) {
              const metaActual = this.metasCatalog.find(
                m => m.metaPromocionId === metaForm.metaPromocionId
              );
              const filtroExistente = metaActual ? metaActual.filtro : null;
              const filtroExistenteId = filtroExistente ? filtroExistente.filtroMetaId : null;
              const filtroPayload = this.commissionPromotionsService.buildFiltroPayload(
                filtro, metaSchema, userId, filtroExistente,
                this.promoConfiguration.promotionName,
                metaShowConfig, metaPlazosCatalog,
                metaPaymentCategoryCatalog, metaCategoriesView
              );
              return filtroExistenteId
              ? this.commissionPromotionsService.editarFiltroMeta(
                this.promotionId, metaForm.metaPromocionId, filtroExistenteId, filtroPayload)
                  : this.commissionPromotionsService.crearFiltroMeta(
                    this.promotionId, metaForm.metaPromocionId, filtroPayload);
            }
            return of(resp);
          })
        )
        .subscribe(
          () => {
            this.toastr.success('Meta actualizada correctamente');
            const idx = this.metasCatalog.findIndex(
              m => m.metaPromocionId === metaForm.metaPromocionId
            );
            if (idx !== -1) {
              // ← Guardar filtro en formato backend para reedición
              this.metasCatalog[idx] = {
                ...metaActualizada,
                filtro: buildFiltroLocal(),
              };
            }
            this.showMetaForm = false;
            this.resetMetaForm();
          },
          (error) => {
            console.error(error);
            this.toastr.error('Error al actualizar la meta');
          }
        );

      } else {

        // ── Crear nueva meta en modo edición ──────────────────────
        const filtroLocal = buildFiltroLocal(); // ← construir ANTES de crear la meta

        const meta: MetaPromocion = {
          catPromotionId: this.promotionId,
          fechaInicio: metaForm.fechaInicio,
          fechaFin: metaForm.fechaFin,
          nombrePromocion: this.promoConfiguration.promotionName || '',
          fechaCorte: metaForm.fechaCorte,
          activa: true,
          objetivo: metaForm.objetivo,
          comisiones: metaComisiones || [],
          filtro: filtroLocal,   // ← formato backend, NO metaConfiguration
        };
        console.log('Meta actualizada a guardar:', meta);

        this.commissionPromotionsService.crearMeta(this.promotionId, meta)
          .pipe(
            switchMap((resp) => {
              if (resp.httpStatusCode !== 200) return of(resp);

              const metaPromocionId = resp.data.metaPromocionId;

              // ← Verificar usando filtroLocal que ya está en formato backend
              if (!filtroLocal) return of(resp);

              const tieneDatos = !!(
                (filtroLocal.listRegion && filtroLocal.listRegion.length) ||
                (filtroLocal.listEstado && filtroLocal.listEstado.length) ||
                (filtroLocal.listSucursal && filtroLocal.listSucursal.length) ||
                (filtroLocal.listProducto && filtroLocal.listProducto.length) ||
                (filtroLocal.listDependencia && filtroLocal.listDependencia.length) ||
                (filtroLocal.listTipoAsesor && filtroLocal.listTipoAsesor.length) ||
                (filtroLocal.listLineaNegocio && filtroLocal.listLineaNegocio.length) ||
                (filtroLocal.listGenero && filtroLocal.listGenero.length) ||
                (filtroLocal.listEdad && filtroLocal.listEdad.length) ||
                (filtroLocal.listEstadoCivil && filtroLocal.listEstadoCivil.length) ||
                (filtroLocal.listTipoEmpleado && filtroLocal.listTipoEmpleado.length) ||
                (filtroLocal.listTipoVenta && filtroLocal.listTipoVenta.length) ||
                (filtroLocal.listNuevoCliente && filtroLocal.listNuevoCliente.length) ||
                (filtroLocal.listMontoCapital && filtroLocal.listMontoCapital.length) ||
                (filtroLocal.listTasaAnual && filtroLocal.listTasaAnual.length) ||
                (filtroLocal.listClavePromocion && filtroLocal.listClavePromocion.length) ||
                (filtroLocal.listCategoriaAsesor && filtroLocal.listCategoriaAsesor.length) ||
                (filtroLocal.listPlazo && filtroLocal.listPlazo.length)
              );

              if (!tieneDatos) return of(resp);

              // ← Ajustar estructura para que el back genere un ID nuevo
              const filtroPayload = {
                ...filtroLocal,
                usuarioId: parseInt(localStorage.getItem('UserId') || '0'),
                activoId: 1,
                tipoConfiguracionId: 0,
                tipoConfiguracion: 'ESQUEMA',
                comisionAditiva: 0,
                estructura: filtroLocal.estructura ? {
                  ...filtroLocal.estructura,
                  estructuraId: null,
                  nombreEstructura: `${this.promoConfiguration.promotionName || 'META'}_FILTRO_META`,
                  usuarioId: parseInt(localStorage.getItem('UserId') || '0'),
                  activoId: 1,
                } : null,
              };

              return this.commissionPromotionsService.crearFiltroMeta(
                this.promotionId,
                metaPromocionId,
                filtroPayload
              ).pipe(map(() => resp));
            })
          )
          .subscribe(
            (resp: any) => {
              this.toastr.success('Meta creada correctamente');
              this.metasCatalog = [
                ...this.metasCatalog,
                {
                  ...meta,
                  metaPromocionId: resp.data.metaPromocionId,
                  filtro: filtroLocal,  // ← guardar en formato backend
                }
              ];
              this.showMetaForm = false;
              this.resetMetaForm();
            },
            (error) => {
              console.error(error);
              this.toastr.error('Error al crear la meta');
            }
          );
      }

    } else {
      // ── Modo creación: acumular localmente ────────────────────────
      const filtroLocal = buildFiltroLocal();

      if (metaForm.metaPromocionId && metaForm.metaPromocionId < 0) {
        // ── Edición de meta local ─────────────────────────────────
        const idx = this.metasCatalog.findIndex(
          m => m.metaPromocionId === metaForm.metaPromocionId
        );
        if (idx !== -1) {
          this.metasCatalog[idx] = {
            ...this.metasCatalog[idx],
            fechaInicio: metaForm.fechaInicio,
            fechaFin: metaForm.fechaFin,
            fechaCorte: metaForm.fechaCorte,
            objetivo: metaForm.objetivo,
            comisiones: metaComisiones || [],
            filtro: filtroLocal,   // ← formato backend
          };
        }
        this.toastr.info('Meta actualizada localmente');
      } else {
        // ── Nueva meta local ──────────────────────────────────────
        const metaLocal: MetaPromocion = {
          metaPromocionId: this.metaIdCounter--,
          catPromotionId: null,
          nombrePromocion: this.promoConfiguration.promotionName || '',
          fechaInicio: metaForm.fechaInicio,
          fechaFin: metaForm.fechaFin,
          fechaCorte: metaForm.fechaCorte,
          objetivo: metaForm.objetivo,
          comisiones: metaComisiones || [],
          filtro: filtroLocal,   // ← formato backend
        };
        this.metasCatalog = [...this.metasCatalog, metaLocal];
        this.toastr.info('Meta agregada, se guardará al confirmar la configuración');
      }

      this.showMetaForm = false;
      this.resetMetaForm();
    }
  }

  replicarConfiguracionEnMeta(): void {
    this.resetMetaForm();

    // ── Construir listPlazo desde los plazos activos de la promoción ──
    let listPlazo: any[] = [];
    if (this.showConfig.fieldPaymentTerm && this.promoConfiguration.paymentTerms.length) {
      if (this.showConfig.fieldCategoryAsesor) {
        // ← Plazos x Categorías
        listPlazo = this.promoConfiguration.paymentTerms.map((term: any) => ({
          plazoId: term.id,
          plazoValor: String(term.name || term.id),
          categoriaId: term.categoryId || null,
          categoriaNombre: term.categoryName || null,
          comision: term.comission || 0,
        }));
      } else {
        // ← Solo Plazos
        listPlazo = this.promoConfiguration.paymentTerms.map((term: any) => ({
          plazoId: term.id,
          plazoValor: String(term.name || term.id),
          categoriaId: null,
          comision: term.comission || 0,
        }));
      }
    }

    // ── Construir listCategoriaAsesor desde las categorías activas ──
    let listCategoriaAsesor: any[] = [];
    if (this.showConfig.fieldCategoryAsesor && this.promoConfiguration.categoryAsesor.length) {
      listCategoriaAsesor = this.promoConfiguration.categoryAsesor.map((cat: any) => ({
        categoriaAsesorId: cat.id,
        categoriaAsesorValor: cat.name || cat.description || '',
      }));
    }

    const filtroReplicado: any = {
      estructura: null,

      // Filtros del Asesor
      typeAsesor: this.showConfig.fieldAsesorType ? [...this.promoConfiguration.typeAsesor] : [],
      businessLine: this.showConfig.fieldBusinessLine ? [...this.promoConfiguration.businessLine] : [],
      tasaAnual: this.showConfig.fieldTasaAnual ? this.promoConfiguration.tasaAnual : 0,

      // Filtros del Cliente
      gender: this.showConfig.fieldGender ? [...this.promoConfiguration.gender] : [],
      minAge: this.showConfig.fieldAge ? this.promoConfiguration.minAge : 0,
      maxAge: this.showConfig.fieldAge ? this.promoConfiguration.maxAge : 100,
      civilStatus: this.showConfig.fieldCivilStatus ? [...this.promoConfiguration.civilStatus] : [],
      typeEmployee: this.showConfig.fieldEmployeeType ? [...this.promoConfiguration.typeEmployee] : [],
      typeSale: this.showConfig.fieldSaleType ? [...this.promoConfiguration.typeSale] : [],
      nuevoCliente: this.showConfig.fieldNuevoCliente ? [...this.promoConfiguration.nuevoCliente] : [],

      // Monto Capital
      minCapitalAmount: this.showConfig.fieldCapitalAmount ? this.promoConfiguration.minCapitalAmount : 0,
      maxCapitalAmount: this.showConfig.fieldCapitalAmount ? this.promoConfiguration.maxCapitalAmount : 10000000,

      // Geografía
      region: this.showConfig.fieldRegion ? [...this.promoConfiguration.region] : [],
      estado: this.showConfig.fieldState ? [...this.promoConfiguration.estado] : [],
      sucursal: this.showConfig.fieldSucursal ? [...this.promoConfiguration.sucursal] : [],
      producto: this.showConfig.fieldProduct ? [...this.promoConfiguration.producto] : [],
      dependencia: this.showConfig.fieldDependency ? [...this.promoConfiguration.dependencia] : [],
      clavePromocion: this.showConfig.fieldClavePromocion ? [...this.promoConfiguration.clavePromocion] : [],

      // Categorías
      categoryAsesor: this.showConfig.fieldCategoryAsesor ? [...this.promoConfiguration.categoryAsesor] : [],

      // ← Listas en formato backend para que preCargarFiltroExistente las procese
      listTipoAsesor: [],
      listLineaNegocio: [],
      listGenero: [],
      listEdad: [],
      listEstadoCivil: [],
      listTipoEmpleado: [],
      listTipoVenta: [],
      listNuevoCliente: [],
      listRegion: [],
      listEstado: [],
      listSucursal: [],
      listDependencia: [],
      listProducto: [],
      listClavePromocion: [],
      listMontoCapital: [],
      listTasaAnual: [],
      // ← Plazos y categorías replicados para que el hijo los pre-cargue
      listPlazo: listPlazo,
      listCategoriaAsesor: listCategoriaAsesor,
    };

    // ← Campos replicados excluyendo Asesores=22 y Plazos=8
    // ← Plazos (8) se excluye del schema pero se replica en listPlazo
    // ← Categorías (5) SÍ se incluye para que el hijo active fieldCategoryAsesor
    const camposExcluidos = [22]; // ← solo excluir Asesores
    const camposReplicados = (this.promoConfiguration.schema && this.promoConfiguration.schema.campos)
      ? this.promoConfiguration.schema.campos.filter(
        (c: any) => c.activoId == 1 && !camposExcluidos.includes(c.campoId)
      )
      : [];

    if (camposReplicados.length) {
      filtroReplicado.estructura = {
        estructuraId: null,
        nombreEstructura: (this.promoConfiguration.promotionName || 'META') + '_FILTRO_META',
        campos: camposReplicados,
        fields: camposReplicados,
      };
    }

    this.metaSeleccionada = { filtro: filtroReplicado } as any;
    this.showMetaForm = true;
    this.toastr.info('Configuración de la promoción replicada en la meta');
  }

  tieneAlgunFiltroConfigurado(): boolean {
    const p = this.promoConfiguration;
    return !!(
      (this.showConfig.fieldAsesorType && p.typeAsesor && p.typeAsesor.length) ||
      (this.showConfig.fieldBusinessLine && p.businessLine && p.businessLine.length) ||
      (this.showConfig.fieldGender && p.gender && p.gender.length) ||
      (this.showConfig.fieldAge && (p.minAge > 0 || p.maxAge < 100)) ||
      (this.showConfig.fieldCivilStatus && p.civilStatus && p.civilStatus.length) ||
      (this.showConfig.fieldEmployeeType && p.typeEmployee && p.typeEmployee.length) ||
      (this.showConfig.fieldSaleType && p.typeSale && p.typeSale.length) ||
      (this.showConfig.fieldNuevoCliente && p.nuevoCliente && p.nuevoCliente.length) ||
      (this.showConfig.fieldCapitalAmount && p.minCapitalAmount > 0) ||
      (this.showConfig.fieldTasaAnual && p.tasaAnual && p.tasaAnual > 0) ||
      (this.showConfig.fieldRegion && p.region && p.region.length) ||
      (this.showConfig.fieldState && p.estado && p.estado.length) ||
      (this.showConfig.fieldSucursal && p.sucursal && p.sucursal.length) ||
      (this.showConfig.fieldProduct && p.producto && p.producto.length) ||
      (this.showConfig.fieldDependency && p.dependencia && p.dependencia.length) ||
      (this.showConfig.fieldClavePromocion && p.clavePromocion && p.clavePromocion.length) ||
      (this.showConfig.fieldCategoryAsesor && p.categoryAsesor && p.categoryAsesor.length) ||
      // ← Plazos: al menos uno seleccionado con comisión > 0
      (this.showConfig.fieldPaymentTerm && p.paymentTerms && p.paymentTerms.length > 0) ||
      // ← Comisión general configurada
      (this.showConfig.fieldCommissionPromotion && p.comisionPromotion && p.comisionPromotion > 0)
    );
  }

  toggleActivarMeta(meta: MetaPromocion): void {
    const accion = meta.activa ? 'desactivar' : 'activar';
    const icono = meta.activa ? 'warning' : 'question';

    Swal.fire({
      title: `¿${meta.activa ? 'Desactivar' : 'Activar'} meta?`,
      text: `¿Confirmas que deseas ${accion} esta meta?`,
      icon: icono,
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: meta.activa ? '#f44336' : '#28a745',
      cancelButtonColor: '#6c757d'
    }).then((result) => {
      if (!result.isConfirmed) return;

      if (this.isEditMode && meta.metaPromocionId > 0) {
        // ← Backend
        this.commissionPromotionsService
          .toggleActivarMeta(this.promotionId, meta.metaPromocionId, !meta.activa)
          .subscribe({
            next: (resp) => {
              if (resp.httpStatusCode === 200) {
                meta.activa = !meta.activa;
                this.toastr.success(`Meta ${accion}da correctamente`);
              } else {
                this.toastr.error(`Error al ${accion} la meta`);
              }
            },
            error: (err) => {
              console.error(err);
              this.toastr.error(`Error al ${accion} la meta`);
            }
          });
      } else {
        // ← Local (modo creación)
        meta.activa = !meta.activa;
        this.toastr.info(`Meta ${accion}da localmente`);
      }
    });
  }
}